// This file is auto-generated by @hey-api/openapi-ts

import {
  createClient,
  createConfig,
  type Options,
  formDataBodySerializer,
} from '@hey-api/client-fetch';
import type {
  GetSocialAccountOverviewError,
  GetSocialAccountOverviewResponse,
  RecognizeSocialAccountsData,
  RecognizeSocialAccountsError,
  RecognizeSocialAccountsResponse2,
  ManualBindSocialAccountsData,
  ManualBindSocialAccountsError,
  ManualBindSocialAccountsResponse,
  StartSocialAccountInteractiveLoginData,
  StartSocialAccountInteractiveLoginError,
  StartSocialAccountInteractiveLoginResponse,
  CheckSocialAccountInteractiveLoginData,
  CheckSocialAccountInteractiveLoginError,
  CheckSocialAccountInteractiveLoginResponse,
  CompleteSocialAccountInteractiveLoginData,
  CompleteSocialAccountInteractiveLoginError,
  CompleteSocialAccountInteractiveLoginResponse,
  SaveSocialAccountLoginCookiesData,
  SaveSocialAccountLoginCookiesError,
  SaveSocialAccountLoginCookiesResponse,
  CloseSocialAccountLoginBrowserData,
  CloseSocialAccountLoginBrowserError,
  CloseSocialAccountLoginBrowserResponse,
  StartSocialAccountLoginBatchData,
  StartSocialAccountLoginBatchError,
  StartSocialAccountLoginBatchResponse,
  GetSocialAccountLoginBatchStatusData,
  GetSocialAccountLoginBatchStatusError,
  GetSocialAccountLoginBatchStatusResponse,
  ContinueSocialAccountLoginBatchData,
  ContinueSocialAccountLoginBatchError,
  ContinueSocialAccountLoginBatchResponse,
  StopSocialAccountLoginBatchData,
  StopSocialAccountLoginBatchError,
  StopSocialAccountLoginBatchResponse,
  CancelOneSocialAccountLoginBatchData,
  CancelOneSocialAccountLoginBatchError,
  CancelOneSocialAccountLoginBatchResponse,
  SaveOneSocialAccountLoginBatchData,
  SaveOneSocialAccountLoginBatchError,
  SaveOneSocialAccountLoginBatchResponse,
  CreateWorkflowSkillData,
  CreateWorkflowSkillError,
  CreateWorkflowSkillResponse,
  ListWorkflowSkillsError,
  ListWorkflowSkillsResponse,
  GetWorkflowSkillData,
  GetWorkflowSkillError,
  GetWorkflowSkillResponse,
  DeleteWorkflowSkillData,
  DeleteWorkflowSkillError,
  DeleteWorkflowSkillResponse,
  InvokeWorkflowSkillData,
  InvokeWorkflowSkillError,
  InvokeWorkflowSkillResponse2,
  ListSocialPlatformsError,
  ListSocialPlatformsResponse,
  ListSocialAccountsData,
  ListSocialAccountsError,
  ListSocialAccountsResponse,
  CreateSocialAccountData,
  CreateSocialAccountError,
  CreateSocialAccountResponse,
  BatchCreateSocialAccountsData,
  BatchCreateSocialAccountsError,
  BatchCreateSocialAccountsResponse2,
  CreateSocialAccountAutoBindingBatchData,
  CreateSocialAccountAutoBindingBatchError,
  CreateSocialAccountAutoBindingBatchResponse,
  StartSocialAccountReloginBatchData,
  StartSocialAccountReloginBatchError,
  StartSocialAccountReloginBatchResponse,
  GetSocialAccountData,
  GetSocialAccountError,
  GetSocialAccountResponse,
  DeleteSocialAccountData,
  DeleteSocialAccountError,
  DeleteSocialAccountResponse,
  UpdateSocialAccountCredentialData,
  UpdateSocialAccountCredentialError,
  UpdateSocialAccountCredentialResponse,
  UpdateSocialAccountProfileData,
  UpdateSocialAccountProfileError,
  UpdateSocialAccountProfileResponse,
  GetSocialAccountWorkflowsData,
  GetSocialAccountWorkflowsError,
  GetSocialAccountWorkflowsResponse,
  UpdateSocialAccountRemarkData,
  UpdateSocialAccountRemarkError,
  UpdateSocialAccountRemarkResponse,
  SaveSocialBrowserStateData,
  SaveSocialBrowserStateError,
  SaveSocialBrowserStateResponse,
  ImportSocialBrowserStateData,
  ImportSocialBrowserStateError,
  ImportSocialBrowserStateResponse,
  ImportSocialBrowserStateFileData,
  ImportSocialBrowserStateFileError,
  ImportSocialBrowserStateFileResponse,
  IssueSocialBrowserStateExportTicketData,
  IssueSocialBrowserStateExportTicketError,
  IssueSocialBrowserStateExportTicketResponse,
  ExportSocialBrowserStateData,
  ExportSocialBrowserStateError,
  ExportSocialBrowserStateResponse,
  UpdateSocialAccountStatusData,
  UpdateSocialAccountStatusError,
  UpdateSocialAccountStatusResponse,
  CreateSocialAccountCategoryData,
  CreateSocialAccountCategoryError,
  CreateSocialAccountCategoryResponse,
  ListSocialAccountCategoriesError,
  ListSocialAccountCategoriesResponse,
  GetSocialAccountCategoryData,
  GetSocialAccountCategoryError,
  GetSocialAccountCategoryResponse,
  UpdateSocialAccountCategoryData,
  UpdateSocialAccountCategoryError,
  UpdateSocialAccountCategoryResponse,
  DeleteSocialAccountCategoryData,
  DeleteSocialAccountCategoryError,
  DeleteSocialAccountCategoryResponse,
  BindSocialAccountToCategoryData,
  BindSocialAccountToCategoryError,
  BindSocialAccountToCategoryResponse,
  UnbindSocialAccountFromCategoryData,
  UnbindSocialAccountFromCategoryError,
  UnbindSocialAccountFromCategoryResponse,
  ListSocialAccountsByCategoryData,
  ListSocialAccountsByCategoryError,
  ListSocialAccountsByCategoryResponse,
  ListCategoriesBySocialAccountData,
  ListCategoriesBySocialAccountError,
  ListCategoriesBySocialAccountResponse,
  BatchBindSocialAccountsToCategoryData,
  BatchBindSocialAccountsToCategoryError,
  BatchBindSocialAccountsToCategoryResponse,
  BatchUnbindSocialAccountsFromCategoryData,
  BatchUnbindSocialAccountsFromCategoryError,
  BatchUnbindSocialAccountsFromCategoryResponse,
  MoveSocialAccountsCategoryData,
  MoveSocialAccountsCategoryError,
  MoveSocialAccountsCategoryResponse2,
  CreateVideoEditProjectData,
  CreateVideoEditProjectError,
  CreateVideoEditProjectResponse,
  GetVideoEditProjectData,
  GetVideoEditProjectError,
  GetVideoEditProjectResponse,
  GetVideoEditVersionData,
  GetVideoEditVersionError,
  GetVideoEditVersionResponse,
  ConfirmVideoEditNarrativeData,
  ConfirmVideoEditNarrativeError,
  ConfirmVideoEditNarrativeResponse,
  RegenerateVideoEditNarrativeData,
  RegenerateVideoEditNarrativeError,
  RegenerateVideoEditNarrativeResponse,
  GetVideoEditProjectSnapshotData,
  GetVideoEditProjectSnapshotError,
  GetVideoEditProjectSnapshotResponse,
  SaveVideoEditProjectSnapshotData,
  SaveVideoEditProjectSnapshotError,
  SaveVideoEditProjectSnapshotResponse,
  AttachVideoEditProjectAssetsData,
  AttachVideoEditProjectAssetsError,
  AttachVideoEditProjectAssetsResponse,
  CompleteVideoManualEditData,
  CompleteVideoManualEditError,
  CompleteVideoManualEditResponse,
  GetVideoEditAssetAccessUrlData,
  GetVideoEditAssetAccessUrlError,
  GetVideoEditAssetAccessUrlResponse,
  EnsureProductionStudioWorkspaceData,
  EnsureProductionStudioWorkspaceError,
  EnsureProductionStudioWorkspaceResponse,
  GetProductionStudioWorkspaceData,
  GetProductionStudioWorkspaceError,
  GetProductionStudioWorkspaceResponse,
  ListProductionStudioClientPacksError,
  ListProductionStudioClientPacksResponse,
  ImportProductionStudioClientPackData,
  ImportProductionStudioClientPackError,
  ImportProductionStudioClientPackResponse,
  UpdateProductionStudioClientPackStatusData,
  UpdateProductionStudioClientPackStatusError,
  UpdateProductionStudioClientPackStatusResponse,
  UpdateProductionStudioClientPackAssetData,
  UpdateProductionStudioClientPackAssetError,
  UpdateProductionStudioClientPackAssetResponse,
  CreateProductionStudioBatchData,
  CreateProductionStudioBatchError,
  CreateProductionStudioBatchResponse,
  GetProductionStudioBatchData,
  GetProductionStudioBatchError,
  GetProductionStudioBatchResponse,
  UpdateProductionStudioBatchData,
  UpdateProductionStudioBatchError,
  UpdateProductionStudioBatchResponse,
  DeleteProductionStudioBatchData,
  DeleteProductionStudioBatchError,
  DeleteProductionStudioBatchResponse,
  CopyProductionStudioBatchData,
  CopyProductionStudioBatchError,
  CopyProductionStudioBatchResponse,
  SaveProductionStudioScriptData,
  SaveProductionStudioScriptError,
  SaveProductionStudioScriptResponse,
  ImportProductionStudioScriptsData,
  ImportProductionStudioScriptsError,
  ImportProductionStudioScriptsResponse,
  RegenerateProductionStudioScriptsData,
  RegenerateProductionStudioScriptsError,
  RegenerateProductionStudioScriptsResponse,
  DeleteProductionStudioScriptData,
  DeleteProductionStudioScriptError,
  DeleteProductionStudioScriptResponse,
  ConfirmProductionStudioScriptData,
  ConfirmProductionStudioScriptError,
  ConfirmProductionStudioScriptResponse,
  ConfirmAllProductionStudioScriptsData,
  ConfirmAllProductionStudioScriptsError,
  ConfirmAllProductionStudioScriptsResponse,
  StartProductionStudioBatchData,
  StartProductionStudioBatchError,
  StartProductionStudioBatchResponse,
  PauseProductionStudioBatchData,
  PauseProductionStudioBatchError,
  PauseProductionStudioBatchResponse,
  CancelProductionStudioBatchData,
  CancelProductionStudioBatchError,
  CancelProductionStudioBatchResponse,
  ReviewProductionStudioOutputData,
  ReviewProductionStudioOutputError,
  ReviewProductionStudioOutputResponse,
  GetProductionStudioOutputAccessUrlData,
  GetProductionStudioOutputAccessUrlError,
  GetProductionStudioOutputAccessUrlResponse,
  GetProductionStudioOutputStrategyArtifactData,
  GetProductionStudioOutputStrategyArtifactError,
  GetProductionStudioOutputStrategyArtifactResponse,
  CreateSocialBrowserSessionData,
  CreateSocialBrowserSessionError,
  CreateSocialBrowserSessionResponse,
  GetSocialBrowserSessionData,
  GetSocialBrowserSessionError,
  GetSocialBrowserSessionResponse,
  IssueSocialBrowserViewerTicketData,
  IssueSocialBrowserViewerTicketError,
  IssueSocialBrowserViewerTicketResponse,
  OpenSocialBrowserViewerConnectionData,
  OpenSocialBrowserViewerConnectionError,
  OpenSocialBrowserViewerConnectionResponse,
  SetSocialBrowserSessionAutomationData,
  SetSocialBrowserSessionAutomationError,
  SetSocialBrowserSessionAutomationResponse,
  CompleteSocialBrowserSessionData,
  CompleteSocialBrowserSessionError,
  CompleteSocialBrowserSessionResponse,
  CancelSocialBrowserSessionData,
  CancelSocialBrowserSessionError,
  CancelSocialBrowserSessionResponse,
  ExtendSocialBrowserSessionData,
  ExtendSocialBrowserSessionError,
  ExtendSocialBrowserSessionResponse,
  GetActiveSocialBrowserSessionBatchError,
  GetActiveSocialBrowserSessionBatchResponse,
  CreateSocialBrowserSessionBatchData,
  CreateSocialBrowserSessionBatchError,
  CreateSocialBrowserSessionBatchResponse,
  GetSocialBrowserSessionBatchData,
  GetSocialBrowserSessionBatchError,
  GetSocialBrowserSessionBatchResponse,
  CancelSocialBrowserSessionBatchData,
  CancelSocialBrowserSessionBatchError,
  CancelSocialBrowserSessionBatchResponse,
  CancelSocialBrowserSessionBatchItemData,
  CancelSocialBrowserSessionBatchItemError,
  CancelSocialBrowserSessionBatchItemResponse,
  GetSocialPublishExecutorStatusError,
  GetSocialPublishExecutorStatusResponse,
  ListMediaLibraryEntriesData,
  ListMediaLibraryEntriesError,
  ListMediaLibraryEntriesResponse2,
  CreateMediaLibraryEntryData,
  CreateMediaLibraryEntryError,
  CreateMediaLibraryEntryResponse,
  SearchMediaLibraryEntriesData,
  SearchMediaLibraryEntriesError,
  SearchMediaLibraryEntriesResponse,
  GetMediaLibraryEntryData,
  GetMediaLibraryEntryError,
  GetMediaLibraryEntryResponse,
  UpdateMediaLibraryEntryData,
  UpdateMediaLibraryEntryError,
  UpdateMediaLibraryEntryResponse,
  BatchDeleteMediaLibraryEntriesData,
  BatchDeleteMediaLibraryEntriesError,
  BatchDeleteMediaLibraryEntriesResponse2,
  GetMediaLibraryEntryAccessUrlData,
  GetMediaLibraryEntryAccessUrlError,
  GetMediaLibraryEntryAccessUrlResponse,
  InitializeMediaLibraryUploadData,
  InitializeMediaLibraryUploadError,
  InitializeMediaLibraryUploadResponse,
  GetMediaLibraryUploadStatusData,
  GetMediaLibraryUploadStatusError,
  GetMediaLibraryUploadStatusResponse,
  SignMediaLibraryUploadPartsData,
  SignMediaLibraryUploadPartsError,
  SignMediaLibraryUploadPartsResponse2,
  CompleteMediaLibraryUploadData,
  CompleteMediaLibraryUploadError,
  CompleteMediaLibraryUploadResponse,
  AbortMediaLibraryUploadData,
  AbortMediaLibraryUploadError,
  AbortMediaLibraryUploadResponse,
  CreateMediaLibraryDownloadTaskData,
  CreateMediaLibraryDownloadTaskError,
  CreateMediaLibraryDownloadTaskResponse,
  GetMediaLibraryDownloadTaskData,
  GetMediaLibraryDownloadTaskError,
  GetMediaLibraryDownloadTaskResponse,
  ListCanvasMaterialsData,
  ListCanvasMaterialsError,
  ListCanvasMaterialsResponse2,
  GetCanvasMaterialAccessUrlData,
  GetCanvasMaterialAccessUrlError,
  GetCanvasMaterialAccessUrlResponse,
  ImportCanvasMaterialsToLibraryData,
  ImportCanvasMaterialsToLibraryError,
  ImportCanvasMaterialsToLibraryResponse,
  ImportCanvasMaterialsFromLibraryData,
  ImportCanvasMaterialsFromLibraryError,
  ImportCanvasMaterialsFromLibraryResponse,
  CreateCanvasMaterialDownloadTaskData,
  CreateCanvasMaterialDownloadTaskError,
  CreateCanvasMaterialDownloadTaskResponse,
  GetCanvasMaterialDownloadTaskData,
  GetCanvasMaterialDownloadTaskError,
  GetCanvasMaterialDownloadTaskResponse,
  ExtractVariablesData,
  ExtractVariablesError,
  ExtractVariablesResponse,
  GenerateAppTemplateData,
  GenerateAppTemplateError,
  GenerateAppTemplateResponse,
  ListMcpServersData,
  ListMcpServersError,
  ListMcpServersResponse2,
  CreateMcpServerData,
  CreateMcpServerError,
  CreateMcpServerResponse,
  UpdateMcpServerData,
  UpdateMcpServerError,
  UpdateMcpServerResponse,
  DeleteMcpServerData,
  DeleteMcpServerError,
  DeleteMcpServerResponse2,
  ValidateMcpServerData,
  ValidateMcpServerError,
  ValidateMcpServerResponse2,
  ListPagesData,
  ListPagesError,
  ListPagesResponse2,
  GetPageDetailData,
  GetPageDetailError,
  GetPageDetailResponse,
  UpdatePageData,
  UpdatePageError,
  UpdatePageResponse2,
  SharePageData,
  SharePageError,
  SharePageResponse2,
  DeletePageNodeData,
  DeletePageNodeError,
  DeletePageNodeResponse2,
  GetPageByCanvasIdData,
  GetPageByCanvasIdError,
  GetPageByCanvasIdResponse,
  AddNodesToCanvasPageData,
  AddNodesToCanvasPageError,
  AddNodesToCanvasPageResponse,
  GetAuthConfigError,
  GetAuthConfigResponse,
  RefreshTokenError,
  RefreshTokenResponse,
  EmailSignupData2,
  EmailSignupError,
  EmailSignupResponse2,
  EmailLoginData2,
  EmailLoginError,
  EmailLoginResponse2,
  CreateVerificationData2,
  CreateVerificationError,
  CreateVerificationResponse2,
  ResendVerificationData,
  ResendVerificationError,
  ResendVerificationResponse,
  CheckVerificationData,
  CheckVerificationError,
  CheckVerificationResponse,
  LogoutError,
  LogoutResponse,
  CheckToolOauthStatusData,
  CheckToolOauthStatusError,
  CheckToolOauthStatusResponse,
  GetCollabTokenError,
  GetCollabTokenResponse2,
  ListCanvasesData,
  ListCanvasesError,
  ListCanvasesResponse,
  GetCanvasDetailData,
  GetCanvasDetailError,
  GetCanvasDetailResponse2,
  GetCanvasDataData,
  GetCanvasDataError,
  GetCanvasDataResponse2,
  ExportCanvasData,
  ExportCanvasError,
  ExportCanvasResponse2,
  ImportCanvasData,
  ImportCanvasError,
  ImportCanvasResponse,
  CreateCanvasData,
  CreateCanvasError,
  CreateCanvasResponse,
  DuplicateCanvasData,
  DuplicateCanvasError,
  DuplicateCanvasResponse,
  UpdateCanvasData,
  UpdateCanvasError,
  UpdateCanvasResponse,
  DeleteCanvasData,
  DeleteCanvasError,
  DeleteCanvasResponse,
  AutoNameCanvasData,
  AutoNameCanvasError,
  AutoNameCanvasResponse2,
  GetCanvasStateData,
  GetCanvasStateError,
  GetCanvasStateResponse2,
  SetCanvasStateData,
  SetCanvasStateError,
  SetCanvasStateResponse,
  GetCanvasTransactionsData,
  GetCanvasTransactionsError,
  GetCanvasTransactionsResponse2,
  SyncCanvasStateData,
  SyncCanvasStateError,
  SyncCanvasStateResponse2,
  CreateCanvasVersionData,
  CreateCanvasVersionError,
  CreateCanvasVersionResponse2,
  GetWorkflowVariablesData,
  GetWorkflowVariablesError,
  GetWorkflowVariablesResponse2,
  UpdateWorkflowVariablesData,
  UpdateWorkflowVariablesError,
  UpdateWorkflowVariablesResponse2,
  ListDriveFilesData,
  ListDriveFilesError,
  ListDriveFilesResponse2,
  CreateDriveFileData,
  CreateDriveFileError,
  CreateDriveFileResponse,
  BatchCreateDriveFilesData,
  BatchCreateDriveFilesError,
  BatchCreateDriveFilesResponse2,
  UpdateDriveFileData,
  UpdateDriveFileError,
  UpdateDriveFileResponse,
  DeleteDriveFileData,
  DeleteDriveFileError,
  DeleteDriveFileResponse,
  ListCanvasTemplatesData,
  ListCanvasTemplatesError,
  ListCanvasTemplatesResponse,
  CreateCanvasTemplateData,
  CreateCanvasTemplateError,
  CreateCanvasTemplateResponse,
  UpdateCanvasTemplateData,
  UpdateCanvasTemplateError,
  UpdateCanvasTemplateResponse,
  ListCanvasTemplateCategoriesError,
  ListCanvasTemplateCategoriesResponse,
  ListResourcesData,
  ListResourcesError,
  ListResourcesResponse,
  GetResourceDetailData,
  GetResourceDetailError,
  GetResourceDetailResponse2,
  UpdateResourceData,
  UpdateResourceError,
  UpdateResourceResponse,
  CreateResourceData,
  CreateResourceError,
  CreateResourceResponse,
  CreateResourceWithFileData,
  CreateResourceWithFileError,
  CreateResourceWithFileResponse,
  BatchCreateResourceData,
  BatchCreateResourceError,
  BatchCreateResourceResponse2,
  ReindexResourceData,
  ReindexResourceError,
  ReindexResourceResponse2,
  DeleteResourceData,
  DeleteResourceError,
  DeleteResourceResponse,
  ListDocumentsData,
  ListDocumentsError,
  ListDocumentsResponse,
  GetDocumentDetailData,
  GetDocumentDetailError,
  GetDocumentDetailResponse2,
  ExportDocumentData,
  ExportDocumentError,
  ExportDocumentResponse,
  StartExportJobData,
  StartExportJobError,
  StartExportJobResponse2,
  GetExportJobStatusData,
  GetExportJobStatusError,
  GetExportJobStatusResponse2,
  DownloadExportJobResultData,
  DownloadExportJobResultError,
  DownloadExportJobResultResponse,
  UpdateDocumentData,
  UpdateDocumentError,
  UpdateDocumentResponse,
  CreateDocumentData,
  CreateDocumentError,
  CreateDocumentResponse,
  DeleteDocumentData,
  DeleteDocumentError,
  DeleteDocumentResponse,
  BatchUpdateDocumentData,
  BatchUpdateDocumentError,
  BatchUpdateDocumentResponse,
  ListProjectsData,
  ListProjectsError,
  ListProjectsResponse,
  GetProjectDetailData,
  GetProjectDetailError,
  GetProjectDetailResponse2,
  CreateProjectData,
  CreateProjectError,
  CreateProjectResponse,
  UpdateProjectData,
  UpdateProjectError,
  UpdateProjectResponse,
  UpdateProjectItemsData,
  UpdateProjectItemsError,
  UpdateProjectItemsResponse,
  DeleteProjectData,
  DeleteProjectError,
  DeleteProjectResponse,
  DeleteProjectItemsData,
  DeleteProjectItemsError,
  DeleteProjectItemsResponse,
  ListCodeArtifactsData,
  ListCodeArtifactsError,
  ListCodeArtifactsResponse,
  GetCodeArtifactDetailData,
  GetCodeArtifactDetailError,
  GetCodeArtifactDetailResponse2,
  CreateCodeArtifactData,
  CreateCodeArtifactError,
  CreateCodeArtifactResponse,
  UpdateCodeArtifactData,
  UpdateCodeArtifactError,
  UpdateCodeArtifactResponse,
  CreateShareData,
  CreateShareError,
  CreateShareResponse2,
  ListSharesData,
  ListSharesError,
  ListSharesResponse,
  DeleteShareData,
  DeleteShareError,
  DeleteShareResponse,
  DuplicateShareData,
  DuplicateShareError,
  DuplicateShareResponse2,
  ListLabelClassesData,
  ListLabelClassesError,
  ListLabelClassesResponse2,
  CreateLabelClassData,
  CreateLabelClassError,
  CreateLabelClassResponse,
  UpdateLabelClassData,
  UpdateLabelClassError,
  UpdateLabelClassResponse,
  DeleteLabelClassData,
  DeleteLabelClassError,
  DeleteLabelClassResponse,
  ListLabelInstancesData,
  ListLabelInstancesError,
  ListLabelInstancesResponse2,
  CreateLabelInstanceData,
  CreateLabelInstanceError,
  CreateLabelInstanceResponse,
  UpdateLabelInstanceData,
  UpdateLabelInstanceError,
  UpdateLabelInstanceResponse,
  DeleteLabelInstanceData,
  DeleteLabelInstanceError,
  DeleteLabelInstanceResponse,
  GetActionResultData,
  GetActionResultError,
  GetActionResultResponse2,
  AbortActionData,
  AbortActionError,
  AbortActionResponse,
  ListSkillsError,
  ListSkillsResponse,
  InvokeSkillData,
  InvokeSkillError,
  InvokeSkillResponse2,
  StreamInvokeSkillData,
  StreamInvokeSkillError,
  StreamInvokeSkillResponse,
  ListSkillInstancesData,
  ListSkillInstancesError,
  ListSkillInstancesResponse,
  CreateSkillInstanceData,
  CreateSkillInstanceError,
  CreateSkillInstanceResponse2,
  UpdateSkillInstanceData,
  UpdateSkillInstanceError,
  UpdateSkillInstanceResponse2,
  PinSkillInstanceData,
  PinSkillInstanceError,
  PinSkillInstanceResponse,
  UnpinSkillInstanceData,
  UnpinSkillInstanceError,
  UnpinSkillInstanceResponse,
  DeleteSkillInstanceData,
  DeleteSkillInstanceError,
  DeleteSkillInstanceResponse,
  ListSkillTriggersData,
  ListSkillTriggersError,
  ListSkillTriggersResponse,
  CreateSkillTriggerData,
  CreateSkillTriggerError,
  CreateSkillTriggerResponse2,
  UpdateSkillTriggerData,
  UpdateSkillTriggerError,
  UpdateSkillTriggerResponse2,
  DeleteSkillTriggerData,
  DeleteSkillTriggerError,
  DeleteSkillTriggerResponse,
  GenerateMediaData,
  GenerateMediaError,
  GenerateMediaResponse,
  CreatePilotSessionData,
  CreatePilotSessionError,
  CreatePilotSessionResponse,
  UpdatePilotSessionData,
  UpdatePilotSessionError,
  UpdatePilotSessionResponse,
  ListPilotSessionsData,
  ListPilotSessionsError,
  ListPilotSessionsResponse2,
  GetPilotSessionDetailData,
  GetPilotSessionDetailError,
  GetPilotSessionDetailResponse2,
  RecoverPilotSessionData,
  RecoverPilotSessionError,
  RecoverPilotSessionResponse,
  ListCopilotSessionsData,
  ListCopilotSessionsError,
  ListCopilotSessionsResponse2,
  DeleteCopilotSessionData,
  DeleteCopilotSessionError,
  DeleteCopilotSessionResponse,
  MaterializeCopilotSessionData,
  MaterializeCopilotSessionError,
  MaterializeCopilotSessionResponse2,
  GetCopilotSessionDetailData,
  GetCopilotSessionDetailError,
  GetCopilotSessionDetailResponse2,
  RestartWorkflowNodeData,
  RestartWorkflowNodeError,
  RestartWorkflowNodeResponse,
  StopPublishTaskData,
  StopPublishTaskError,
  StopPublishTaskResponse,
  InitializeWorkflowData,
  InitializeWorkflowError,
  InitializeWorkflowResponse2,
  AbortWorkflowData,
  AbortWorkflowError,
  AbortWorkflowResponse,
  ListWorkflowExecutionsData,
  ListWorkflowExecutionsError,
  ListWorkflowExecutionsResponse2,
  GetWorkflowDetailData,
  GetWorkflowDetailError,
  GetWorkflowDetailResponse2,
  GetWorkflowPlanDetailData,
  GetWorkflowPlanDetailError,
  GetWorkflowPlanDetailResponse2,
  CreateWorkflowAppData,
  CreateWorkflowAppError,
  CreateWorkflowAppResponse2,
  DeleteWorkflowAppData,
  DeleteWorkflowAppError,
  DeleteWorkflowAppResponse,
  GetWorkflowAppDetailData,
  GetWorkflowAppDetailError,
  GetWorkflowAppDetailResponse2,
  ExecuteWorkflowAppData,
  ExecuteWorkflowAppError,
  ExecuteWorkflowAppResponse2,
  ListWorkflowAppsData,
  ListWorkflowAppsError,
  ListWorkflowAppsResponse2,
  GetTemplateGenerationStatusData,
  GetTemplateGenerationStatusError,
  GetTemplateGenerationStatusResponse2,
  CreateScheduleData,
  CreateScheduleError,
  CreateScheduleResponse2,
  UpdateScheduleData,
  UpdateScheduleError,
  UpdateScheduleResponse2,
  DeleteScheduleData,
  DeleteScheduleError,
  DeleteScheduleResponse2,
  ListSchedulesData,
  ListSchedulesError,
  ListSchedulesResponse2,
  GetScheduleDetailData,
  GetScheduleDetailError,
  GetScheduleDetailResponse2,
  GetScheduleRecordsData,
  GetScheduleRecordsError,
  GetScheduleRecordsResponse2,
  ListAllScheduleRecordsData,
  ListAllScheduleRecordsError,
  ListAllScheduleRecordsResponse2,
  GetAvailableToolsError,
  GetAvailableToolsResponse2,
  GetScheduleRecordDetailData,
  GetScheduleRecordDetailError,
  GetScheduleRecordDetailResponse2,
  GetRecordSnapshotData,
  GetRecordSnapshotError,
  GetRecordSnapshotResponse2,
  TriggerScheduleManuallyData,
  TriggerScheduleManuallyError,
  TriggerScheduleManuallyResponse2,
  RetryScheduleRecordData,
  RetryScheduleRecordError,
  RetryScheduleRecordResponse2,
  CreateCliApiKeyData2,
  CreateCliApiKeyError,
  CreateCliApiKeyResponse2,
  ListCliApiKeysError,
  ListCliApiKeysResponse2,
  UpdateCliApiKeyData,
  UpdateCliApiKeyError,
  UpdateCliApiKeyResponse,
  RevokeCliApiKeyData,
  RevokeCliApiKeyError,
  RevokeCliApiKeyResponse,
  GetOpenapiConfigData,
  GetOpenapiConfigError,
  GetOpenapiConfigResponse,
  UpdateOpenapiConfigData,
  UpdateOpenapiConfigError,
  UpdateOpenapiConfigResponse,
  UploadOpenapiFilesData,
  UploadOpenapiFilesError,
  UploadOpenapiFilesResponse,
  SearchWorkflowsViaApiData,
  SearchWorkflowsViaApiError,
  SearchWorkflowsViaApiResponse,
  GetWorkflowDetailViaApiData,
  GetWorkflowDetailViaApiError,
  GetWorkflowDetailViaApiResponse,
  RunWorkflowViaApiData,
  RunWorkflowViaApiError,
  RunWorkflowViaApiResponse,
  GenerateWorkflowViaCopilotData,
  GenerateWorkflowViaCopilotError,
  GenerateWorkflowViaCopilotResponse,
  GetWorkflowStatusViaApiData,
  GetWorkflowStatusViaApiError,
  GetWorkflowStatusViaApiResponse2,
  GetWorkflowOutputData,
  GetWorkflowOutputError,
  GetWorkflowOutputResponse2,
  AbortWorkflowViaApiData,
  AbortWorkflowViaApiError,
  AbortWorkflowViaApiResponse,
  GetSettingsError,
  GetSettingsResponse,
  UpdateSettingsData,
  UpdateSettingsError,
  UpdateSettingsResponse,
  CheckSettingsFieldData,
  CheckSettingsFieldError,
  CheckSettingsFieldResponse2,
  GetFormDefinitionError,
  GetFormDefinitionResponse2,
  SubmitFormData,
  SubmitFormError,
  SubmitFormResponse,
  HasFilledFormError,
  HasFilledFormResponse2,
  GetCreditRechargeData,
  GetCreditRechargeError,
  GetCreditRechargeResponse2,
  GetCreditUsageData,
  GetCreditUsageError,
  GetCreditUsageResponse2,
  GetCreditBalanceError,
  GetCreditBalanceResponse,
  GetCreditUsageByResultIdData,
  GetCreditUsageByResultIdError,
  GetCreditUsageByResultIdResponse2,
  GetCreditUsageByExecutionIdData,
  GetCreditUsageByExecutionIdError,
  GetCreditUsageByExecutionIdResponse2,
  GetCreditUsageByCanvasIdData,
  GetCreditUsageByCanvasIdError,
  GetCreditUsageByCanvasIdResponse2,
  ListInvitationCodesError,
  ListInvitationCodesResponse2,
  ActivateInvitationCodeData,
  ActivateInvitationCodeError,
  ActivateInvitationCodeResponse,
  HasBeenInvitedError,
  HasBeenInvitedResponse2,
  GetSubscriptionPlansError,
  GetSubscriptionPlansResponse2,
  GetSubscriptionUsageError,
  GetSubscriptionUsageResponse2,
  ListModelsError,
  ListModelsResponse2,
  CreateCheckoutSessionData,
  CreateCheckoutSessionError,
  CreateCheckoutSessionResponse2,
  CreateCreditPackCheckoutSessionData,
  CreateCreditPackCheckoutSessionError,
  CreateCreditPackCheckoutSessionResponse,
  CreatePortalSessionError,
  CreatePortalSessionResponse2,
  CreatePayOrderData,
  CreatePayOrderError,
  CreatePayOrderResponse2,
  GetPayOrderData,
  GetPayOrderError,
  GetPayOrderResponse2,
  SearchData,
  SearchError,
  SearchResponse2,
  MultiLingualWebSearchData,
  MultiLingualWebSearchError,
  MultiLingualWebSearchResponse2,
  GetModelOptionsError,
  GetModelOptionsResponse,
  ListManagedModelsData,
  ListManagedModelsError,
  ListManagedModelsResponse2,
  CreateManagedModelData,
  CreateManagedModelError,
  CreateManagedModelResponse,
  UpdateManagedModelData,
  UpdateManagedModelError,
  UpdateManagedModelResponse,
  UpdateManagedModelStatusData,
  UpdateManagedModelStatusError,
  UpdateManagedModelStatusResponse,
  DeleteManagedModelData,
  DeleteManagedModelError,
  DeleteManagedModelResponse,
  ListProvidersData,
  ListProvidersError,
  ListProvidersResponse2,
  CreateProviderData,
  CreateProviderError,
  CreateProviderResponse,
  UpdateProviderData,
  UpdateProviderError,
  UpdateProviderResponse,
  DeleteProviderData,
  DeleteProviderError,
  DeleteProviderResponse,
  TestProviderConnectionData,
  TestProviderConnectionError,
  TestProviderConnectionResponse2,
  ListProviderItemsData,
  ListProviderItemsError,
  ListProviderItemsResponse2,
  ListProviderItemOptionsData,
  ListProviderItemOptionsError,
  ListProviderItemOptionsResponse2,
  CreateProviderItemData,
  CreateProviderItemError,
  CreateProviderItemResponse,
  BatchCreateProviderItemsData,
  BatchCreateProviderItemsError,
  BatchCreateProviderItemsResponse,
  UpdateProviderItemData,
  UpdateProviderItemError,
  UpdateProviderItemResponse,
  BatchUpdateProviderItemsData,
  BatchUpdateProviderItemsError,
  BatchUpdateProviderItemsResponse,
  DeleteProviderItemData,
  DeleteProviderItemError,
  DeleteProviderItemResponse,
  ListToolsData,
  ListToolsError,
  ListToolsResponse2,
  ListUserToolsError,
  ListUserToolsResponse2,
  ListToolsetInventoryError,
  ListToolsetInventoryResponse2,
  ListToolsetsData,
  ListToolsetsError,
  ListToolsetsResponse2,
  CreateToolsetData,
  CreateToolsetError,
  CreateToolsetResponse,
  UpdateToolsetData,
  UpdateToolsetError,
  UpdateToolsetResponse,
  DeleteToolsetData,
  DeleteToolsetError,
  DeleteToolsetResponse,
  ExportToolsetDefinitionsData,
  ExportToolsetDefinitionsError,
  ExportToolsetDefinitionsResponse2,
  ExecuteToolData,
  ExecuteToolError,
  ExecuteToolResponse2,
  GetToolCallResultData,
  GetToolCallResultError,
  GetToolCallResultResponse2,
  AuthorizeComposioConnectionData,
  AuthorizeComposioConnectionError,
  AuthorizeComposioConnectionResponse,
  RevokeComposioConnectionData,
  RevokeComposioConnectionError,
  RevokeComposioConnectionResponse,
  GetComposioConnectionStatusData,
  GetComposioConnectionStatusError,
  GetComposioConnectionStatusResponse,
  ScrapeData,
  ScrapeError,
  ScrapeResponse,
  UploadData,
  UploadError,
  UploadResponse2,
  ServeStaticData,
  ServeStaticError,
  ServeStaticResponse,
  ConvertData,
  ConvertError,
  ConvertResponse2,
  GetPromptSuggestionsError,
  GetPromptSuggestionsResponse2,
  GetAvailableVouchersError,
  GetAvailableVouchersResponse2,
  ListUserVouchersError,
  ListUserVouchersResponse2,
  ValidateVoucherData,
  ValidateVoucherError,
  ValidateVoucherResponse2,
  CreateVoucherInvitationData,
  CreateVoucherInvitationError,
  CreateVoucherInvitationResponse2,
  VerifyVoucherInvitationData,
  VerifyVoucherInvitationError,
  VerifyVoucherInvitationResponse2,
  ClaimVoucherInvitationData,
  ClaimVoucherInvitationError,
  ClaimVoucherInvitationResponse2,
  ListPromptSkillsData,
  ListPromptSkillsError,
  ListPromptSkillsResponse,
  GetPromptSkillDetailData,
  GetPromptSkillDetailError,
  GetPromptSkillDetailResponse,
  CreatePromptSkillData,
  CreatePromptSkillError,
  CreatePromptSkillResponse,
  UpdatePromptSkillData,
  UpdatePromptSkillError,
  UpdatePromptSkillResponse,
  TogglePromptSkillData,
  TogglePromptSkillError,
  TogglePromptSkillResponse,
  DeletePromptSkillData,
  DeletePromptSkillError,
  DeletePromptSkillResponse,
} from './types.gen';

export const client = createClient(createConfig());

/**
 * 获取社交账号数据概览
 * 返回当前用户未删除且已完成绑定的账号总数、国内外平台统计及各平台明细。
 */
export const getSocialAccountOverview = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetSocialAccountOverviewResponse,
    GetSocialAccountOverviewError,
    ThrowOnError
  >({
    ...options,
    url: '/social-account/overview',
  });
};

/**
 * 识别社交账号（占位）
 * 预留批量解析账号、密码和二次验证密钥的能力；后端实现前返回 501，不保存数据。
 */
export const recognizeSocialAccounts = <ThrowOnError extends boolean = false>(
  options: Options<RecognizeSocialAccountsData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    RecognizeSocialAccountsResponse2,
    RecognizeSocialAccountsError,
    ThrowOnError
  >({
    ...options,
    url: '/social-account/account/recognize',
  });
};

/**
 * 手动绑定社交账号（占位）
 * 预留一次请求完成账号创建和分类绑定的能力；后端实现前返回 501，当前请使用批量创建与批量绑定分类接口。
 */
export const manualBindSocialAccounts = <ThrowOnError extends boolean = false>(
  options: Options<ManualBindSocialAccountsData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    ManualBindSocialAccountsResponse,
    ManualBindSocialAccountsError,
    ThrowOnError
  >({
    ...options,
    url: '/social-account/account/manual-bind',
  });
};

/**
 * 启动账号交互登录
 * 为指定社交账号启动浏览器登录会话，返回浏览器标识和可视化登录地址。
 */
export const startSocialAccountInteractiveLogin = <ThrowOnError extends boolean = false>(
  options: Options<StartSocialAccountInteractiveLoginData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    StartSocialAccountInteractiveLoginResponse,
    StartSocialAccountInteractiveLoginError,
    ThrowOnError
  >({
    ...options,
    url: '/media-publish/fingerprint/interactive-login/start',
  });
};

/**
 * 查询交互登录状态
 * 查询指定浏览器会话的登录状态和当前页面信息。
 */
export const checkSocialAccountInteractiveLogin = <ThrowOnError extends boolean = false>(
  options: Options<CheckSocialAccountInteractiveLoginData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    CheckSocialAccountInteractiveLoginResponse,
    CheckSocialAccountInteractiveLoginError,
    ThrowOnError
  >({
    ...options,
    url: '/media-publish/fingerprint/interactive-login/check',
  });
};

/**
 * 确认并完成账号登录
 * 验证浏览器中的平台登录状态，成功后保存账号 Cookie 并更新账号登录状态。
 */
export const completeSocialAccountInteractiveLogin = <ThrowOnError extends boolean = false>(
  options: Options<CompleteSocialAccountInteractiveLoginData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CompleteSocialAccountInteractiveLoginResponse,
    CompleteSocialAccountInteractiveLoginError,
    ThrowOnError
  >({
    ...options,
    url: '/media-publish/fingerprint/interactive-login/complete',
  });
};

/**
 * 手动保存登录 Cookie
 * 将交互登录浏览器中的 Cookie 保存到指定社交账号，适用于自动检测未识别但用户已登录的情况。
 */
export const saveSocialAccountLoginCookies = <ThrowOnError extends boolean = false>(
  options: Options<SaveSocialAccountLoginCookiesData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    SaveSocialAccountLoginCookiesResponse,
    SaveSocialAccountLoginCookiesError,
    ThrowOnError
  >({
    ...options,
    url: '/media-publish/fingerprint/interactive-login/save-cookies',
  });
};

/**
 * 关闭登录浏览器
 * 关闭指定的交互登录浏览器会话并释放资源，不删除账号数据。
 */
export const closeSocialAccountLoginBrowser = <ThrowOnError extends boolean = false>(
  options: Options<CloseSocialAccountLoginBrowserData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CloseSocialAccountLoginBrowserResponse,
    CloseSocialAccountLoginBrowserError,
    ThrowOnError
  >({
    ...options,
    url: '/media-publish/fingerprint/close-browser',
  });
};

/**
 * 启动批量账号登录
 * 按账号数组创建批量登录任务并启动浏览器会话。
 */
export const startSocialAccountLoginBatch = <ThrowOnError extends boolean = false>(
  options: Options<StartSocialAccountLoginBatchData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    StartSocialAccountLoginBatchResponse,
    StartSocialAccountLoginBatchError,
    ThrowOnError
  >({
    ...options,
    url: '/media-publish/fingerprint/batch/start',
  });
};

/**
 * 查询批量登录进度
 * 返回批量登录任务及各账号会话的当前状态。
 */
export const getSocialAccountLoginBatchStatus = <ThrowOnError extends boolean = false>(
  options: Options<GetSocialAccountLoginBatchStatusData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetSocialAccountLoginBatchStatusResponse,
    GetSocialAccountLoginBatchStatusError,
    ThrowOnError
  >({
    ...options,
    url: '/media-publish/fingerprint/batch/status',
  });
};

/**
 * 继续批量账号登录
 * 继续处理暂停或等待人工确认的批量登录任务。
 */
export const continueSocialAccountLoginBatch = <ThrowOnError extends boolean = false>(
  options: Options<ContinueSocialAccountLoginBatchData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    ContinueSocialAccountLoginBatchResponse,
    ContinueSocialAccountLoginBatchError,
    ThrowOnError
  >({
    ...options,
    url: '/media-publish/fingerprint/batch/continue',
  });
};

/**
 * 停止批量账号登录
 * 停止指定批量登录任务并结束尚未完成的会话；本次新建且从未绑定成功的账号会被软删除，不进入账号管理列表，已绑定成功的账号保留。
 */
export const stopSocialAccountLoginBatch = <ThrowOnError extends boolean = false>(
  options: Options<StopSocialAccountLoginBatchData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    StopSocialAccountLoginBatchResponse,
    StopSocialAccountLoginBatchError,
    ThrowOnError
  >({
    ...options,
    url: '/media-publish/fingerprint/batch/stop',
  });
};

/**
 * 取消批量登录中的单个账号
 * 取消批量登录任务中的指定账号会话，其他账号继续处理；本次新建且从未绑定成功的账号会被软删除，不进入账号管理列表。
 */
export const cancelOneSocialAccountLoginBatch = <ThrowOnError extends boolean = false>(
  options: Options<CancelOneSocialAccountLoginBatchData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CancelOneSocialAccountLoginBatchResponse,
    CancelOneSocialAccountLoginBatchError,
    ThrowOnError
  >({
    ...options,
    url: '/media-publish/fingerprint/batch/cancel-one',
  });
};

/**
 * 保存批量登录中当前账号的登录状态
 * 校验当前账号确实处于已登录状态后保存 Cookie 并结束该账号会话；未检测到登录成功时返回错误且不改变账号状态。自动绑定的“确认”与手动绑定的“保存登录信息”共用本接口。
 */
export const saveOneSocialAccountLoginBatch = <ThrowOnError extends boolean = false>(
  options: Options<SaveOneSocialAccountLoginBatchData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    SaveOneSocialAccountLoginBatchResponse,
    SaveOneSocialAccountLoginBatchError,
    ThrowOnError
  >({
    ...options,
    url: '/media-publish/fingerprint/batch/save-one',
  });
};

/**
 * 创建或更新工作流技能
 * 从工作流计划、指定画布或直接提交的计划快照创建技能；当前用户下同名技能会更新。
 */
export const createWorkflowSkill = <ThrowOnError extends boolean = false>(
  options: Options<CreateWorkflowSkillData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateWorkflowSkillResponse,
    CreateWorkflowSkillError,
    ThrowOnError
  >({
    ...options,
    url: '/workflow-skill/create',
  });
};

/**
 * 获取可用工作流技能
 * 返回当前用户创建的技能及系统从公开模板沉淀的全局技能。
 */
export const listWorkflowSkills = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListWorkflowSkillsResponse,
    ListWorkflowSkillsError,
    ThrowOnError
  >({
    ...options,
    url: '/workflow-skill/list',
  });
};

/**
 * 获取工作流技能详情
 * 根据技能 ID 获取当前用户可见的个人或全局工作流技能快照。
 */
export const getWorkflowSkill = <ThrowOnError extends boolean = false>(
  options: Options<GetWorkflowSkillData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetWorkflowSkillResponse,
    GetWorkflowSkillError,
    ThrowOnError
  >({
    ...options,
    url: '/workflow-skill/detail',
  });
};

/**
 * 删除当前用户的工作流技能
 * 软删除当前用户创建的技能；系统全局技能不能通过该接口删除。
 */
export const deleteWorkflowSkill = <ThrowOnError extends boolean = false>(
  options: Options<DeleteWorkflowSkillData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    DeleteWorkflowSkillResponse,
    DeleteWorkflowSkillError,
    ThrowOnError
  >({
    ...options,
    url: '/workflow-skill/delete',
  });
};

/**
 * 调用工作流技能并创建画布
 * 使用个人或全局技能的计划快照创建新画布，并用请求变量覆盖同名工作流变量。
 */
export const invokeWorkflowSkill = <ThrowOnError extends boolean = false>(
  options: Options<InvokeWorkflowSkillData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    InvokeWorkflowSkillResponse2,
    InvokeWorkflowSkillError,
    ThrowOnError
  >({
    ...options,
    url: '/workflow-skill/invoke',
  });
};

/**
 * 获取支持的社交平台
 * 返回当前发布系统支持的平台标识、类型编号和中文名称。
 */
export const listSocialPlatforms = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListSocialPlatformsResponse,
    ListSocialPlatformsError,
    ThrowOnError
  >({
    ...options,
    url: '/social-account/platforms',
  });
};

/**
 * 获取当前用户的社交账号
 * 查询当前登录用户的全部社交账号，可按平台标识筛选，并返回账号登录凭据明文。
 */
export const listSocialAccounts = <ThrowOnError extends boolean = false>(
  options?: Options<ListSocialAccountsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListSocialAccountsResponse,
    ListSocialAccountsError,
    ThrowOnError
  >({
    ...options,
    url: '/social-account/account/list',
  });
};

/**
 * 创建社交账号并可选保存登录凭据
 * 创建当前用户的社交账号；登录标识、密码和 TOTP 密钥按明文保存，响应返回凭据明文及存在性。
 */
export const createSocialAccount = <ThrowOnError extends boolean = false>(
  options: Options<CreateSocialAccountData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateSocialAccountResponse,
    CreateSocialAccountError,
    ThrowOnError
  >({
    ...options,
    url: '/social-account/account/create',
  });
};

/**
 * 批量创建社交账号并保存登录凭据
 * 每批最多 100 个；登录凭据按明文保存并在响应返回。
 */
export const batchCreateSocialAccounts = <ThrowOnError extends boolean = false>(
  options: Options<BatchCreateSocialAccountsData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    BatchCreateSocialAccountsResponse2,
    BatchCreateSocialAccountsError,
    ThrowOnError
  >({
    ...options,
    url: '/social-account/account/batch-create',
  });
};

/**
 * 原子创建账号并启动自动绑定批次
 * 在单个数据库事务内创建待绑定账号、分类关系、批次和会话；事务提交后启动调度，任一步失败均不留下孤立账号。
 */
export const createSocialAccountAutoBindingBatch = <ThrowOnError extends boolean = false>(
  options: Options<CreateSocialAccountAutoBindingBatchData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateSocialAccountAutoBindingBatchResponse,
    CreateSocialAccountAutoBindingBatchError,
    ThrowOnError
  >({
    ...options,
    url: '/social-account/account/auto-bind',
  });
};

/**
 * 失效账号重新登录，启动单账号自动绑定批次
 * 为已存在的账号启动一个只有一个槽位的自动登录批次，复用批量绑定的自动填表、人机验证暂停与登录态校验；Cookie 文件名仍按账号 ID 命名。
 */
export const startSocialAccountReloginBatch = <ThrowOnError extends boolean = false>(
  options: Options<StartSocialAccountReloginBatchData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    StartSocialAccountReloginBatchResponse,
    StartSocialAccountReloginBatchError,
    ThrowOnError
  >({
    ...options,
    url: '/social-account/account/{accountId}/relogin',
  });
};

/**
 * 获取当前用户的社交账号详情
 * 根据账号 ID 获取当前用户拥有的社交账号详情，不返回任何敏感凭据内容。
 */
export const getSocialAccount = <ThrowOnError extends boolean = false>(
  options: Options<GetSocialAccountData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetSocialAccountResponse,
    GetSocialAccountError,
    ThrowOnError
  >({
    ...options,
    url: '/social-account/account/{accountId}',
  });
};

/**
 * 软删除当前用户的社交账号
 * 软删除当前用户拥有的社交账号，并阻止其继续用于新发布任务。
 */
export const deleteSocialAccount = <ThrowOnError extends boolean = false>(
  options: Options<DeleteSocialAccountData, ThrowOnError>,
) => {
  return (options?.client ?? client).delete<
    DeleteSocialAccountResponse,
    DeleteSocialAccountError,
    ThrowOnError
  >({
    ...options,
    url: '/social-account/account/{accountId}',
  });
};

/**
 * 覆盖更新账号登录凭据
 * 凭据使用 AES-256-GCM 保存；响应仅返回存在性，永不返回明文。
 */
export const updateSocialAccountCredential = <ThrowOnError extends boolean = false>(
  options: Options<UpdateSocialAccountCredentialData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    UpdateSocialAccountCredentialResponse,
    UpdateSocialAccountCredentialError,
    ThrowOnError
  >({
    ...options,
    url: '/social-account/account/{accountId}/credential',
  });
};

/**
 * 更新平台账号资料
 * 由登录验证或资料采集流程更新平台用户名、头像和平台 Logo，不修改账号备注或登录凭据。
 */
export const updateSocialAccountProfile = <ThrowOnError extends boolean = false>(
  options: Options<UpdateSocialAccountProfileData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    UpdateSocialAccountProfileResponse,
    UpdateSocialAccountProfileError,
    ThrowOnError
  >({
    ...options,
    url: '/social-account/account/{accountId}/profile',
  });
};

/**
 * 查询账号关联工作流
 * 按当前用户和账号变量快照查询使用该账号的工作流执行记录，可按执行状态筛选。
 */
export const getSocialAccountWorkflows = <ThrowOnError extends boolean = false>(
  options: Options<GetSocialAccountWorkflowsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetSocialAccountWorkflowsResponse,
    GetSocialAccountWorkflowsError,
    ThrowOnError
  >({
    ...options,
    url: '/social-account/account/{accountId}/workflows',
  });
};

/**
 * 更新社交账号备注
 * 更新当前用户拥有的社交账号展示备注，不修改平台登录凭据。
 */
export const updateSocialAccountRemark = <ThrowOnError extends boolean = false>(
  options: Options<UpdateSocialAccountRemarkData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    UpdateSocialAccountRemarkResponse,
    UpdateSocialAccountRemarkError,
    ThrowOnError
  >({
    ...options,
    url: '/social-account/account/{accountId}/remark',
  });
};

/**
 * 导入并等待验证浏览器登录状态
 * 校验账号平台域名后加密保存 Playwright Storage State；导入后为待验证状态，不直接标记为有效登录。
 */
export const saveSocialBrowserState = <ThrowOnError extends boolean = false>(
  options: Options<SaveSocialBrowserStateData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    SaveSocialBrowserStateResponse,
    SaveSocialBrowserStateError,
    ThrowOnError
  >({
    ...options,
    url: '/social-account/account/{accountId}/browser-state',
  });
};

/**
 * 安全导入 Cookie 或浏览器登录状态
 * 接受 Cookie JSON 数组或 Playwright Storage State，限制 2 MiB，仅保留当前账号平台白名单域名并加密保存；必须通过互动浏览器验证后才会成为有效账号。
 */
export const importSocialBrowserState = <ThrowOnError extends boolean = false>(
  options: Options<ImportSocialBrowserStateData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    ImportSocialBrowserStateResponse,
    ImportSocialBrowserStateError,
    ThrowOnError
  >({
    ...options,
    url: '/social-account/account/{accountId}/browser-state/import',
  });
};

/**
 * 从文件安全导入 Cookie
 * 接受不超过 2 MiB 的 JSON 或 Netscape Cookie txt 文件，校验当前平台域名后加密保存为待验证状态。
 */
export const importSocialBrowserStateFile = <ThrowOnError extends boolean = false>(
  options: Options<ImportSocialBrowserStateFileData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    ImportSocialBrowserStateFileResponse,
    ImportSocialBrowserStateFileError,
    ThrowOnError
  >({
    ...options,
    ...formDataBodySerializer,
    headers: {
      'Content-Type': null,
      ...options?.headers,
    },
    url: '/social-account/account/{accountId}/browser-state/import-file',
  });
};

/**
 * 签发一次性 Cookie 导出令牌
 * 校验账号归属后签发 60 秒内有效且只能使用一次的下载令牌，响应和日志均不包含 Cookie 内容。
 */
export const issueSocialBrowserStateExportTicket = <ThrowOnError extends boolean = false>(
  options: Options<IssueSocialBrowserStateExportTicketData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    IssueSocialBrowserStateExportTicketResponse,
    IssueSocialBrowserStateExportTicketError,
    ThrowOnError
  >({
    ...options,
    url: '/social-account/account/{accountId}/browser-state/export-ticket',
  });
};

/**
 * 使用一次性令牌下载 Cookie
 * 令牌校验通过后以 ZIP 附件下载当前平台白名单域名内的 Storage State JSON，并立即销毁令牌。
 */
export const exportSocialBrowserState = <ThrowOnError extends boolean = false>(
  options: Options<ExportSocialBrowserStateData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ExportSocialBrowserStateResponse,
    ExportSocialBrowserStateError,
    ThrowOnError
  >({
    ...options,
    url: '/social-account/account/{accountId}/browser-state/export',
  });
};

/**
 * 更新社交账号启用状态
 * 启用或停用当前用户拥有的社交账号；停用后的账号不会被选入新的发布任务。
 */
export const updateSocialAccountStatus = <ThrowOnError extends boolean = false>(
  options: Options<UpdateSocialAccountStatusData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    UpdateSocialAccountStatusResponse,
    UpdateSocialAccountStatusError,
    ThrowOnError
  >({
    ...options,
    url: '/social-account/account/{accountId}/status',
  });
};

/**
 * 创建社交账号分类
 * 为当前用户创建账号分类，同一用户下分类名称不可重复。
 */
export const createSocialAccountCategory = <ThrowOnError extends boolean = false>(
  options: Options<CreateSocialAccountCategoryData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateSocialAccountCategoryResponse,
    CreateSocialAccountCategoryError,
    ThrowOnError
  >({
    ...options,
    url: '/social-account/category/create',
  });
};

/**
 * 获取社交账号分类列表
 * 返回当前用户未删除的全部账号分类。
 */
export const listSocialAccountCategories = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListSocialAccountCategoriesResponse,
    ListSocialAccountCategoriesError,
    ThrowOnError
  >({
    ...options,
    url: '/social-account/category/list',
  });
};

/**
 * 获取社交账号分类详情
 * 根据分类 ID 获取当前用户拥有的账号分类详情。
 */
export const getSocialAccountCategory = <ThrowOnError extends boolean = false>(
  options: Options<GetSocialAccountCategoryData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetSocialAccountCategoryResponse,
    GetSocialAccountCategoryError,
    ThrowOnError
  >({
    ...options,
    url: '/social-account/category/{categoryId}',
  });
};

/**
 * 更新社交账号分类
 * 更新当前用户拥有的账号分类名称、说明或图标。
 */
export const updateSocialAccountCategory = <ThrowOnError extends boolean = false>(
  options: Options<UpdateSocialAccountCategoryData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    UpdateSocialAccountCategoryResponse,
    UpdateSocialAccountCategoryError,
    ThrowOnError
  >({
    ...options,
    url: '/social-account/category/{categoryId}',
  });
};

/**
 * 删除社交账号分类
 * 软删除当前用户拥有的账号分类，并解除该分类下的账号关联。
 */
export const deleteSocialAccountCategory = <ThrowOnError extends boolean = false>(
  options: Options<DeleteSocialAccountCategoryData, ThrowOnError>,
) => {
  return (options?.client ?? client).delete<
    DeleteSocialAccountCategoryResponse,
    DeleteSocialAccountCategoryError,
    ThrowOnError
  >({
    ...options,
    url: '/social-account/category/{categoryId}',
  });
};

/**
 * 将社交账号加入分类
 * 将当前用户拥有的一个社交账号关联到一个账号分类。
 */
export const bindSocialAccountToCategory = <ThrowOnError extends boolean = false>(
  options: Options<BindSocialAccountToCategoryData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    BindSocialAccountToCategoryResponse,
    BindSocialAccountToCategoryError,
    ThrowOnError
  >({
    ...options,
    url: '/social-account/account/{accountId}/bind-category/{categoryId}',
  });
};

/**
 * 将社交账号移出分类
 * 解除当前用户拥有的社交账号与指定分类之间的关联。
 */
export const unbindSocialAccountFromCategory = <ThrowOnError extends boolean = false>(
  options: Options<UnbindSocialAccountFromCategoryData, ThrowOnError>,
) => {
  return (options?.client ?? client).delete<
    UnbindSocialAccountFromCategoryResponse,
    UnbindSocialAccountFromCategoryError,
    ThrowOnError
  >({
    ...options,
    url: '/social-account/account/{accountId}/unbind-category/{categoryId}',
  });
};

/**
 * 获取分类下的社交账号
 * 返回当前用户指定分类下全部未删除的社交账号，包含登录凭据明文。
 */
export const listSocialAccountsByCategory = <ThrowOnError extends boolean = false>(
  options: Options<ListSocialAccountsByCategoryData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListSocialAccountsByCategoryResponse,
    ListSocialAccountsByCategoryError,
    ThrowOnError
  >({
    ...options,
    url: '/social-account/category/{categoryId}/accounts',
  });
};

/**
 * 获取社交账号所属分类
 * 返回当前用户指定社交账号关联的全部未删除分类。
 */
export const listCategoriesBySocialAccount = <ThrowOnError extends boolean = false>(
  options: Options<ListCategoriesBySocialAccountData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListCategoriesBySocialAccountResponse,
    ListCategoriesBySocialAccountError,
    ThrowOnError
  >({
    ...options,
    url: '/social-account/account/{accountId}/categories',
  });
};

/**
 * 批量将社交账号加入分类
 * 将当前用户拥有的多个社交账号批量关联到一个分类；已存在的关联会被跳过。
 */
export const batchBindSocialAccountsToCategory = <ThrowOnError extends boolean = false>(
  options: Options<BatchBindSocialAccountsToCategoryData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    BatchBindSocialAccountsToCategoryResponse,
    BatchBindSocialAccountsToCategoryError,
    ThrowOnError
  >({
    ...options,
    url: '/social-account/account/batch-bind-category',
  });
};

/**
 * 批量将社交账号移出分类
 * 批量解除当前用户拥有的多个社交账号与指定分类之间的关联。
 */
export const batchUnbindSocialAccountsFromCategory = <ThrowOnError extends boolean = false>(
  options: Options<BatchUnbindSocialAccountsFromCategoryData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    BatchUnbindSocialAccountsFromCategoryResponse,
    BatchUnbindSocialAccountsFromCategoryError,
    ThrowOnError
  >({
    ...options,
    url: '/social-account/account/batch-unbind-category',
  });
};

/**
 * 批量移动社交账号分类
 * 在一个原子操作中将多个账号从原分类移动到目标分类；目标关联和原关联解除会一起提交，任一步失败则整体回滚。
 */
export const moveSocialAccountsCategory = <ThrowOnError extends boolean = false>(
  options: Options<MoveSocialAccountsCategoryData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    MoveSocialAccountsCategoryResponse2,
    MoveSocialAccountsCategoryError,
    ThrowOnError
  >({
    ...options,
    url: '/social-account/account/move-category',
  });
};

/**
 * 创建或取得工作流视频工程
 * 按当前用户、工作流执行和节点幂等创建服务端视频工程及首个粗剪版本。
 */
export const createVideoEditProject = <ThrowOnError extends boolean = false>(
  options: Options<CreateVideoEditProjectData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateVideoEditProjectResponse,
    CreateVideoEditProjectError,
    ThrowOnError
  >({
    ...options,
    url: '/video-edit/projects',
  });
};

/**
 * 获取视频工程及版本
 */
export const getVideoEditProject = <ThrowOnError extends boolean = false>(
  options: Options<GetVideoEditProjectData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetVideoEditProjectResponse,
    GetVideoEditProjectError,
    ThrowOnError
  >({
    ...options,
    url: '/video-edit/projects/{projectId}',
  });
};

/**
 * 获取视频工程版本
 */
export const getVideoEditVersion = <ThrowOnError extends boolean = false>(
  options: Options<GetVideoEditVersionData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetVideoEditVersionResponse,
    GetVideoEditVersionError,
    ThrowOnError
  >({
    ...options,
    url: '/video-edit/projects/{projectId}/versions/{versionId}',
  });
};

/**
 * 确认粗剪叙事文案并继续规划渲染
 */
export const confirmVideoEditNarrative = <ThrowOnError extends boolean = false>(
  options: Options<ConfirmVideoEditNarrativeData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    ConfirmVideoEditNarrativeResponse,
    ConfirmVideoEditNarrativeError,
    ThrowOnError
  >({
    ...options,
    url: '/video-edit/projects/{projectId}/narrative/confirm',
  });
};

/**
 * 重新生成粗剪叙事文案草稿
 */
export const regenerateVideoEditNarrative = <ThrowOnError extends boolean = false>(
  options: Options<RegenerateVideoEditNarrativeData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    RegenerateVideoEditNarrativeResponse,
    RegenerateVideoEditNarrativeError,
    ThrowOnError
  >({
    ...options,
    url: '/video-edit/projects/{projectId}/narrative/regenerate',
  });
};

/**
 * 获取 OpenCut 工程快照
 */
export const getVideoEditProjectSnapshot = <ThrowOnError extends boolean = false>(
  options: Options<GetVideoEditProjectSnapshotData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetVideoEditProjectSnapshotResponse,
    GetVideoEditProjectSnapshotError,
    ThrowOnError
  >({
    ...options,
    url: '/video-edit/projects/{projectId}/snapshot',
  });
};

/**
 * 乐观锁保存 OpenCut 工程快照
 */
export const saveVideoEditProjectSnapshot = <ThrowOnError extends boolean = false>(
  options: Options<SaveVideoEditProjectSnapshotData, ThrowOnError>,
) => {
  return (options?.client ?? client).put<
    SaveVideoEditProjectSnapshotResponse,
    SaveVideoEditProjectSnapshotError,
    ThrowOnError
  >({
    ...options,
    url: '/video-edit/projects/{projectId}/snapshot',
  });
};

/**
 * 将素材库资产附加到 OpenCut 工程
 */
export const attachVideoEditProjectAssets = <ThrowOnError extends boolean = false>(
  options: Options<AttachVideoEditProjectAssetsData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    AttachVideoEditProjectAssetsResponse,
    AttachVideoEditProjectAssetsError,
    ThrowOnError
  >({
    ...options,
    url: '/video-edit/projects/{projectId}/assets',
  });
};

/**
 * 将 OpenCut 导出保存为新的编辑版本
 */
export const completeVideoManualEdit = <ThrowOnError extends boolean = false>(
  options: Options<CompleteVideoManualEditData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CompleteVideoManualEditResponse,
    CompleteVideoManualEditError,
    ThrowOnError
  >({
    ...options,
    url: '/video-edit/projects/{projectId}/complete-manual-edit',
  });
};

/**
 * 获取视频工程素材短期访问地址
 */
export const getVideoEditAssetAccessUrl = <ThrowOnError extends boolean = false>(
  options: Options<GetVideoEditAssetAccessUrlData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetVideoEditAssetAccessUrlResponse,
    GetVideoEditAssetAccessUrlError,
    ThrowOnError
  >({
    ...options,
    url: '/video-edit/assets/{assetId}/access-url',
  });
};

/**
 * 创建或取得画布 Production Studio 工作台
 */
export const ensureProductionStudioWorkspace = <ThrowOnError extends boolean = false>(
  options: Options<EnsureProductionStudioWorkspaceData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    EnsureProductionStudioWorkspaceResponse,
    EnsureProductionStudioWorkspaceError,
    ThrowOnError
  >({
    ...options,
    url: '/production-studio/workspaces',
  });
};

/**
 * 查询 Production Studio 工作台和全部批次
 */
export const getProductionStudioWorkspace = <ThrowOnError extends boolean = false>(
  options: Options<GetProductionStudioWorkspaceData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetProductionStudioWorkspaceResponse,
    GetProductionStudioWorkspaceError,
    ThrowOnError
  >({
    ...options,
    url: '/production-studio/workspaces/{workspaceId}',
  });
};

/**
 * 查询可管理的 Production Studio 客户包版本
 */
export const listProductionStudioClientPacks = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListProductionStudioClientPacksResponse,
    ListProductionStudioClientPacksError,
    ThrowOnError
  >({
    ...options,
    url: '/production-studio/client-packs',
  });
};

/**
 * 导入自定义 Production Studio Skill 客户包
 */
export const importProductionStudioClientPack = <ThrowOnError extends boolean = false>(
  options: Options<ImportProductionStudioClientPackData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    ImportProductionStudioClientPackResponse,
    ImportProductionStudioClientPackError,
    ThrowOnError
  >({
    ...options,
    ...formDataBodySerializer,
    headers: {
      'Content-Type': null,
      ...options?.headers,
    },
    url: '/production-studio/client-packs/import',
  });
};

/**
 * 启用或停用自定义客户包版本
 */
export const updateProductionStudioClientPackStatus = <ThrowOnError extends boolean = false>(
  options: Options<UpdateProductionStudioClientPackStatusData, ThrowOnError>,
) => {
  return (options?.client ?? client).patch<
    UpdateProductionStudioClientPackStatusResponse,
    UpdateProductionStudioClientPackStatusError,
    ThrowOnError
  >({
    ...options,
    url: '/production-studio/client-packs/{packVersionId}/status',
  });
};

/**
 * 校正未启用客户包的品牌素材用途
 */
export const updateProductionStudioClientPackAsset = <ThrowOnError extends boolean = false>(
  options: Options<UpdateProductionStudioClientPackAssetData, ThrowOnError>,
) => {
  return (options?.client ?? client).patch<
    UpdateProductionStudioClientPackAssetResponse,
    UpdateProductionStudioClientPackAssetError,
    ThrowOnError
  >({
    ...options,
    url: '/production-studio/client-packs/{packVersionId}/assets/{assetId}',
  });
};

/**
 * 创建 Production Studio 项目批次
 */
export const createProductionStudioBatch = <ThrowOnError extends boolean = false>(
  options: Options<CreateProductionStudioBatchData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateProductionStudioBatchResponse,
    CreateProductionStudioBatchError,
    ThrowOnError
  >({
    ...options,
    url: '/production-studio/workspaces/{workspaceId}/batches',
  });
};

/**
 * 查询 Production Studio 批次详情
 */
export const getProductionStudioBatch = <ThrowOnError extends boolean = false>(
  options: Options<GetProductionStudioBatchData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetProductionStudioBatchResponse,
    GetProductionStudioBatchError,
    ThrowOnError
  >({
    ...options,
    url: '/production-studio/batches/{batchId}',
  });
};

/**
 * 更新 Production Studio 批次配置
 */
export const updateProductionStudioBatch = <ThrowOnError extends boolean = false>(
  options: Options<UpdateProductionStudioBatchData, ThrowOnError>,
) => {
  return (options?.client ?? client).patch<
    UpdateProductionStudioBatchResponse,
    UpdateProductionStudioBatchError,
    ThrowOnError
  >({
    ...options,
    url: '/production-studio/batches/{batchId}',
  });
};

/**
 * 删除尚未交付的 Production Studio 批次
 */
export const deleteProductionStudioBatch = <ThrowOnError extends boolean = false>(
  options: Options<DeleteProductionStudioBatchData, ThrowOnError>,
) => {
  return (options?.client ?? client).delete<
    DeleteProductionStudioBatchResponse,
    DeleteProductionStudioBatchError,
    ThrowOnError
  >({
    ...options,
    url: '/production-studio/batches/{batchId}',
  });
};

/**
 * 复制 Production Studio 批次为独立草稿
 */
export const copyProductionStudioBatch = <ThrowOnError extends boolean = false>(
  options: Options<CopyProductionStudioBatchData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CopyProductionStudioBatchResponse,
    CopyProductionStudioBatchError,
    ThrowOnError
  >({
    ...options,
    url: '/production-studio/batches/{batchId}/copy',
  });
};

/**
 * 保存 Production Studio 文案新版本
 */
export const saveProductionStudioScript = <ThrowOnError extends boolean = false>(
  options: Options<SaveProductionStudioScriptData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    SaveProductionStudioScriptResponse,
    SaveProductionStudioScriptError,
    ThrowOnError
  >({
    ...options,
    url: '/production-studio/batches/{batchId}/scripts',
  });
};

/**
 * 批量导入 Production Studio 文案
 */
export const importProductionStudioScripts = <ThrowOnError extends boolean = false>(
  options: Options<ImportProductionStudioScriptsData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    ImportProductionStudioScriptsResponse,
    ImportProductionStudioScriptsError,
    ThrowOnError
  >({
    ...options,
    url: '/production-studio/batches/{batchId}/scripts/import',
  });
};

/**
 * 按新要求重新生成 Production Studio 文案
 */
export const regenerateProductionStudioScripts = <ThrowOnError extends boolean = false>(
  options: Options<RegenerateProductionStudioScriptsData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    RegenerateProductionStudioScriptsResponse,
    RegenerateProductionStudioScriptsError,
    ThrowOnError
  >({
    ...options,
    url: '/production-studio/batches/{batchId}/scripts/regenerate',
  });
};

/**
 * 删除 Production Studio 文案版本
 */
export const deleteProductionStudioScript = <ThrowOnError extends boolean = false>(
  options: Options<DeleteProductionStudioScriptData, ThrowOnError>,
) => {
  return (options?.client ?? client).delete<
    DeleteProductionStudioScriptResponse,
    DeleteProductionStudioScriptError,
    ThrowOnError
  >({
    ...options,
    url: '/production-studio/batches/{batchId}/scripts/{scriptId}',
  });
};

/**
 * 确认 Production Studio 文案版本
 */
export const confirmProductionStudioScript = <ThrowOnError extends boolean = false>(
  options: Options<ConfirmProductionStudioScriptData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    ConfirmProductionStudioScriptResponse,
    ConfirmProductionStudioScriptError,
    ThrowOnError
  >({
    ...options,
    url: '/production-studio/batches/{batchId}/scripts/confirm',
  });
};

/**
 * 确认 Production Studio 全部最新文案
 */
export const confirmAllProductionStudioScripts = <ThrowOnError extends boolean = false>(
  options: Options<ConfirmAllProductionStudioScriptsData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    ConfirmAllProductionStudioScriptsResponse,
    ConfirmAllProductionStudioScriptsError,
    ThrowOnError
  >({
    ...options,
    url: '/production-studio/batches/{batchId}/scripts/confirm-all',
  });
};

/**
 * 启动或继续 Production Studio 批次流水线
 */
export const startProductionStudioBatch = <ThrowOnError extends boolean = false>(
  options: Options<StartProductionStudioBatchData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    StartProductionStudioBatchResponse,
    StartProductionStudioBatchError,
    ThrowOnError
  >({
    ...options,
    url: '/production-studio/batches/{batchId}/start',
  });
};

/**
 * 暂停 Production Studio 批次
 */
export const pauseProductionStudioBatch = <ThrowOnError extends boolean = false>(
  options: Options<PauseProductionStudioBatchData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    PauseProductionStudioBatchResponse,
    PauseProductionStudioBatchError,
    ThrowOnError
  >({
    ...options,
    url: '/production-studio/batches/{batchId}/pause',
  });
};

/**
 * 取消 Production Studio 批次
 */
export const cancelProductionStudioBatch = <ThrowOnError extends boolean = false>(
  options: Options<CancelProductionStudioBatchData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CancelProductionStudioBatchResponse,
    CancelProductionStudioBatchError,
    ThrowOnError
  >({
    ...options,
    url: '/production-studio/batches/{batchId}/cancel',
  });
};

/**
 * 人工批准或驳回 Production Studio 成片
 */
export const reviewProductionStudioOutput = <ThrowOnError extends boolean = false>(
  options: Options<ReviewProductionStudioOutputData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    ReviewProductionStudioOutputResponse,
    ReviewProductionStudioOutputError,
    ThrowOnError
  >({
    ...options,
    url: '/production-studio/batches/{batchId}/outputs/{outputId}/review',
  });
};

/**
 * 获取 Production Studio 成片预览地址
 */
export const getProductionStudioOutputAccessUrl = <ThrowOnError extends boolean = false>(
  options: Options<GetProductionStudioOutputAccessUrlData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetProductionStudioOutputAccessUrlResponse,
    GetProductionStudioOutputAccessUrlError,
    ThrowOnError
  >({
    ...options,
    url: '/production-studio/outputs/{outputId}/access-url',
  });
};

/**
 * 查询 Production Studio 成片完整策略追溯产物
 */
export const getProductionStudioOutputStrategyArtifact = <ThrowOnError extends boolean = false>(
  options: Options<GetProductionStudioOutputStrategyArtifactData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetProductionStudioOutputStrategyArtifactResponse,
    GetProductionStudioOutputStrategyArtifactError,
    ThrowOnError
  >({
    ...options,
    url: '/production-studio/outputs/{outputId}/strategy-artifact',
  });
};

/**
 * 创建短期登录或人工接管会话
 * 为当前用户拥有的账号创建有时效的登录或人工接管会话；同一账号重复发起相同用途时返回尚未结束的现有会话，不会重复启动浏览器。
 */
export const createSocialBrowserSession = <ThrowOnError extends boolean = false>(
  options: Options<CreateSocialBrowserSessionData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateSocialBrowserSessionResponse,
    CreateSocialBrowserSessionError,
    ThrowOnError
  >({
    ...options,
    url: '/media-publish/accounts/{accountId}/browser-sessions',
  });
};

/**
 * 查询当前用户的浏览器会话
 * 查询当前用户拥有的浏览器会话状态和过期时间，不返回凭据或浏览器 Storage State。
 */
export const getSocialBrowserSession = <ThrowOnError extends boolean = false>(
  options: Options<GetSocialBrowserSessionData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetSocialBrowserSessionResponse,
    GetSocialBrowserSessionError,
    ThrowOnError
  >({
    ...options,
    url: '/media-publish/browser-sessions/{sessionId}',
  });
};

/**
 * 签发浏览器画面短期票据
 * 仅 waiting_user 会话可签发；票据 60 秒内首次使用并绑定当前用户和会话，重新签发会立即使旧票据失效。
 */
export const issueSocialBrowserViewerTicket = <ThrowOnError extends boolean = false>(
  options: Options<IssueSocialBrowserViewerTicketData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    IssueSocialBrowserViewerTicketResponse,
    IssueSocialBrowserViewerTicketError,
    ThrowOnError
  >({
    ...options,
    url: '/media-publish/browser-sessions/{sessionId}/viewer-ticket',
  });
};

/**
 * 用一次性票据建立浏览器画面连接
 * 原子消费一次性 viewer ticket 并返回当前会话的短期画面连接元数据；noVNC 使用固定同源 WSS 路径，viewer token 通过 WebSocket 子协议传递，RFB 凭据仅在本响应返回一次。API 不接受前端指定 host、port 或 DISPLAY，同一票据重放会被拒绝。
 */
export const openSocialBrowserViewerConnection = <ThrowOnError extends boolean = false>(
  options: Options<OpenSocialBrowserViewerConnectionData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    OpenSocialBrowserViewerConnectionResponse,
    OpenSocialBrowserViewerConnectionError,
    ThrowOnError
  >({
    ...options,
    url: '/media-publish/browser-sessions/{sessionId}/viewer-connections',
  });
};

/**
 * 暂停或恢复浏览器会话自动操作
 * 仅 waiting_user 会话可切换。暂停后 MPP 停止自动 TOTP、页面与 frame 探测及中间设备状态保存，但 noVNC 操作、保存登录状态和取消会话保持可用。
 */
export const setSocialBrowserSessionAutomation = <ThrowOnError extends boolean = false>(
  options: Options<SetSocialBrowserSessionAutomationData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    SetSocialBrowserSessionAutomationResponse,
    SetSocialBrowserSessionAutomationError,
    ThrowOnError
  >({
    ...options,
    url: '/media-publish/browser-sessions/{sessionId}/automation',
  });
};

/**
 * 验证并保存浏览器登录状态
 * 由 MPP 验证当前平台登录特征并导出 Storage State；只有验证成功时才加密写入账号并标记有效。
 */
export const completeSocialBrowserSession = <ThrowOnError extends boolean = false>(
  options: Options<CompleteSocialBrowserSessionData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CompleteSocialBrowserSessionResponse,
    CompleteSocialBrowserSessionError,
    ThrowOnError
  >({
    ...options,
    url: '/media-publish/browser-sessions/{sessionId}/complete',
  });
};

/**
 * 取消互动浏览器会话
 * 幂等取消排队或运行中的会话并清理 MPP 浏览器资源；已结束会话直接返回当前状态。
 */
export const cancelSocialBrowserSession = <ThrowOnError extends boolean = false>(
  options: Options<CancelSocialBrowserSessionData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CancelSocialBrowserSessionResponse,
    CancelSocialBrowserSessionError,
    ThrowOnError
  >({
    ...options,
    url: '/media-publish/browser-sessions/{sessionId}/cancel',
  });
};

/**
 * 续期互动浏览器会话
 * 每个未结束会话最多续期一次，默认延长 15 分钟；服务端同步更新 MPP 过期时间。
 */
export const extendSocialBrowserSession = <ThrowOnError extends boolean = false>(
  options: Options<ExtendSocialBrowserSessionData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    ExtendSocialBrowserSessionResponse,
    ExtendSocialBrowserSessionError,
    ThrowOnError
  >({
    ...options,
    url: '/media-publish/browser-sessions/{sessionId}/extend',
  });
};

/**
 * 恢复当前未结束的自动绑定批次
 * 返回当前用户最近的排队中或绑定中批次，用于页面刷新后恢复自动绑定弹窗；没有未结束批次时 data 为 null。
 */
export const getActiveSocialBrowserSessionBatch = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetActiveSocialBrowserSessionBatchResponse,
    GetActiveSocialBrowserSessionBatchError,
    ThrowOnError
  >({
    ...options,
    url: '/media-publish/browser-session-batches',
  });
};

/**
 * 创建批量账号登录会话
 * 对 1 至 100 个当前用户账号建立持久化批次，服务端按单用户和全局最多 3 个互动会话调度。
 */
export const createSocialBrowserSessionBatch = <ThrowOnError extends boolean = false>(
  options: Options<CreateSocialBrowserSessionBatchData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateSocialBrowserSessionBatchResponse,
    CreateSocialBrowserSessionBatchError,
    ThrowOnError
  >({
    ...options,
    url: '/media-publish/browser-session-batches',
  });
};

/**
 * 查询批量账号登录进度
 * 返回当前用户批次汇总与每个账号会话状态，不返回凭据、Cookie 或内部执行器地址。
 */
export const getSocialBrowserSessionBatch = <ThrowOnError extends boolean = false>(
  options: Options<GetSocialBrowserSessionBatchData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetSocialBrowserSessionBatchResponse,
    GetSocialBrowserSessionBatchError,
    ThrowOnError
  >({
    ...options,
    url: '/media-publish/browser-session-batches/{batchId}',
  });
};

/**
 * 取消整个批量登录会话
 * 取消批次内全部排队项，并逐个结束运行中的浏览器会话；该操作幂等。
 */
export const cancelSocialBrowserSessionBatch = <ThrowOnError extends boolean = false>(
  options: Options<CancelSocialBrowserSessionBatchData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CancelSocialBrowserSessionBatchResponse,
    CancelSocialBrowserSessionBatchError,
    ThrowOnError
  >({
    ...options,
    url: '/media-publish/browser-session-batches/{batchId}/cancel',
  });
};

/**
 * 取消批量登录中的单个会话
 * 只允许取消当前用户指定批次内的单个会话；取消后调度器会自动启动后续排队项。
 */
export const cancelSocialBrowserSessionBatchItem = <ThrowOnError extends boolean = false>(
  options: Options<CancelSocialBrowserSessionBatchItemData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CancelSocialBrowserSessionBatchItemResponse,
    CancelSocialBrowserSessionBatchItemError,
    ThrowOnError
  >({
    ...options,
    url: '/media-publish/browser-session-batches/{batchId}/sessions/{sessionId}/cancel',
  });
};

/**
 * 查询媒体发布执行器状态
 * 返回脱敏健康状态、11 平台能力、mock 标记和画面模式，不返回 MPP 地址、端口或内部 Token。
 */
export const getSocialPublishExecutorStatus = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetSocialPublishExecutorStatusResponse,
    GetSocialPublishExecutorStatusError,
    ThrowOnError
  >({
    ...options,
    url: '/media-publish/executor/status',
  });
};

/**
 * 列出当前目录直属条目
 * 不传 parentId 时列出根目录；一次返回全部直属文件夹和文件，文件夹优先并按规范化名称稳定排序。
 */
export const listMediaLibraryEntries = <ThrowOnError extends boolean = false>(
  options?: Options<ListMediaLibraryEntriesData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListMediaLibraryEntriesResponse2,
    ListMediaLibraryEntriesError,
    ThrowOnError
  >({
    ...options,
    url: '/media-library/entries',
  });
};

/**
 * 创建文件夹条目
 * 在根目录或指定文件夹下创建文件夹；同一目录内文件与文件夹共用名称空间。
 */
export const createMediaLibraryEntry = <ThrowOnError extends boolean = false>(
  options: Options<CreateMediaLibraryEntryData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateMediaLibraryEntryResponse,
    CreateMediaLibraryEntryError,
    ThrowOnError
  >({
    ...options,
    url: '/media-library/entries',
  });
};

/**
 * 搜索全部文件条目
 * 在当前用户全素材库中按文件名执行不区分大小写的包含搜索；百分号和下划线按普通字符匹配，不搜索文件夹。
 */
export const searchMediaLibraryEntries = <ThrowOnError extends boolean = false>(
  options: Options<SearchMediaLibraryEntriesData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    SearchMediaLibraryEntriesResponse,
    SearchMediaLibraryEntriesError,
    ThrowOnError
  >({
    ...options,
    url: '/media-library/entries/search',
  });
};

/**
 * 获取条目详情
 * 返回文件或文件夹详情，以及从根目录到其父目录的祖先条目。
 */
export const getMediaLibraryEntry = <ThrowOnError extends boolean = false>(
  options: Options<GetMediaLibraryEntryData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetMediaLibraryEntryResponse,
    GetMediaLibraryEntryError,
    ThrowOnError
  >({
    ...options,
    url: '/media-library/entries/{entryId}',
  });
};

/**
 * 改名或移动条目
 * 文件和文件夹使用同一接口；parentId 为 null 表示移到根目录。文件改名不得改变扩展名，文件夹不得移动到自身或后代。
 */
export const updateMediaLibraryEntry = <ThrowOnError extends boolean = false>(
  options: Options<UpdateMediaLibraryEntryData, ThrowOnError>,
) => {
  return (options?.client ?? client).patch<
    UpdateMediaLibraryEntryResponse,
    UpdateMediaLibraryEntryError,
    ThrowOnError
  >({
    ...options,
    url: '/media-library/entries/{entryId}',
  });
};

/**
 * 混合批量删除条目
 * 文件夹按整棵子树递归删除；逐项尽力执行且不设业务条数上限。祖先和后代同时选中时后代标记 deleted_by_ancestor。
 */
export const batchDeleteMediaLibraryEntries = <ThrowOnError extends boolean = false>(
  options: Options<BatchDeleteMediaLibraryEntriesData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    BatchDeleteMediaLibraryEntriesResponse2,
    BatchDeleteMediaLibraryEntriesError,
    ThrowOnError
  >({
    ...options,
    url: '/media-library/entries/batch-delete',
  });
};

/**
 * 获取文件条目访问地址
 * 获取具有时效性的文件预览或下载地址；文件夹返回类型错误，不直接暴露对象存储路径。
 */
export const getMediaLibraryEntryAccessUrl = <ThrowOnError extends boolean = false>(
  options: Options<GetMediaLibraryEntryAccessUrlData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetMediaLibraryEntryAccessUrlResponse,
    GetMediaLibraryEntryAccessUrlError,
    ThrowOnError
  >({
    ...options,
    url: '/media-library/entries/{entryId}/access-url',
  });
};

/**
 * 初始化素材分片上传
 * 创建分片上传会话并返回分片大小和数量；同一 clientRequestId 可用于幂等重试。
 */
export const initializeMediaLibraryUpload = <ThrowOnError extends boolean = false>(
  options: Options<InitializeMediaLibraryUploadData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    InitializeMediaLibraryUploadResponse,
    InitializeMediaLibraryUploadError,
    ThrowOnError
  >({
    ...options,
    url: '/media-library/uploads',
  });
};

/**
 * 获取分片上传进度
 * 查询已上传分片和缺失分片编号，用于断点续传。
 */
export const getMediaLibraryUploadStatus = <ThrowOnError extends boolean = false>(
  options: Options<GetMediaLibraryUploadStatusData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetMediaLibraryUploadStatusResponse,
    GetMediaLibraryUploadStatusError,
    ThrowOnError
  >({
    ...options,
    url: '/media-library/uploads/{sessionId}',
  });
};

/**
 * 获取分片上传签名地址
 * 为指定分片编号生成限时上传地址；单次最多申请 10 个分片。
 */
export const signMediaLibraryUploadParts = <ThrowOnError extends boolean = false>(
  options: Options<SignMediaLibraryUploadPartsData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    SignMediaLibraryUploadPartsResponse2,
    SignMediaLibraryUploadPartsError,
    ThrowOnError
  >({
    ...options,
    url: '/media-library/uploads/{sessionId}/part-urls',
  });
};

/**
 * 完成素材分片上传
 * 校验对象大小并合并全部分片，成功后生成素材记录并异步处理缩略图。
 */
export const completeMediaLibraryUpload = <ThrowOnError extends boolean = false>(
  options: Options<CompleteMediaLibraryUploadData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CompleteMediaLibraryUploadResponse,
    CompleteMediaLibraryUploadError,
    ThrowOnError
  >({
    ...options,
    url: '/media-library/uploads/{sessionId}/complete',
  });
};

/**
 * 取消素材分片上传
 * 取消未完成的分片上传会话并清理已上传分片。
 */
export const abortMediaLibraryUpload = <ThrowOnError extends boolean = false>(
  options: Options<AbortMediaLibraryUploadData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    AbortMediaLibraryUploadResponse,
    AbortMediaLibraryUploadError,
    ThrowOnError
  >({
    ...options,
    url: '/media-library/uploads/{sessionId}/abort',
  });
};

/**
 * 创建素材打包下载任务
 * 接受文件和文件夹条目且不设业务条数上限；文件夹递归展开并去重，ZIP 保留相对目录结构。
 */
export const createMediaLibraryDownloadTask = <ThrowOnError extends boolean = false>(
  options: Options<CreateMediaLibraryDownloadTaskData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateMediaLibraryDownloadTaskResponse,
    CreateMediaLibraryDownloadTaskError,
    ThrowOnError
  >({
    ...options,
    url: '/media-library/download-tasks',
  });
};

/**
 * 获取素材打包下载任务
 * 查询 ZIP 打包进度；ready 状态返回限时下载地址，failed 状态返回错误信息。
 */
export const getMediaLibraryDownloadTask = <ThrowOnError extends boolean = false>(
  options: Options<GetMediaLibraryDownloadTaskData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetMediaLibraryDownloadTaskResponse,
    GetMediaLibraryDownloadTaskError,
    ThrowOnError
  >({
    ...options,
    url: '/media-library/download-tasks/{taskId}',
  });
};

/**
 * 查询画布素材
 * 按“我的上传”或“我的创作”分页查询当前用户拥有画布中的 present 素材，不返回对象存储键。
 */
export const listCanvasMaterials = <ThrowOnError extends boolean = false>(
  options: Options<ListCanvasMaterialsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListCanvasMaterialsResponse2,
    ListCanvasMaterialsError,
    ThrowOnError
  >({
    ...options,
    url: '/canvases/{canvasId}/materials',
  });
};

/**
 * 获取画布素材访问地址
 * 重新校验文件归属和源对象后，返回 10 分钟有效的预览或下载地址。
 */
export const getCanvasMaterialAccessUrl = <ThrowOnError extends boolean = false>(
  options: Options<GetCanvasMaterialAccessUrlData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetCanvasMaterialAccessUrlResponse,
    GetCanvasMaterialAccessUrlError,
    ThrowOnError
  >({
    ...options,
    url: '/canvases/{canvasId}/materials/{fileId}/access-url',
  });
};

/**
 * 保存画布素材到素材库
 * 仅允许把“我的创作”复制到素材库目标目录，允许部分成功；相同幂等键和参数返回原批次，相同键不同参数返回冲突。
 */
export const importCanvasMaterialsToLibrary = <ThrowOnError extends boolean = false>(
  options: Options<ImportCanvasMaterialsToLibraryData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    ImportCanvasMaterialsToLibraryResponse,
    ImportCanvasMaterialsToLibraryError,
    ThrowOnError
  >({
    ...options,
    url: '/canvases/{canvasId}/materials/imports',
  });
};

/**
 * 从素材库导入素材到当前画布
 * 校验当前用户拥有的素材库文件，复制独立对象并创建当前画布“我的上传”素材；相同幂等键和参数不会重复创建文件。
 */
export const importCanvasMaterialsFromLibrary = <ThrowOnError extends boolean = false>(
  options: Options<ImportCanvasMaterialsFromLibraryData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    ImportCanvasMaterialsFromLibraryResponse,
    ImportCanvasMaterialsFromLibraryError,
    ThrowOnError
  >({
    ...options,
    url: '/canvases/{canvasId}/materials/from-library',
  });
};

/**
 * 创建画布素材打包下载任务
 * 按请求顺序冻结全部 fileIds 的文件名、对象键和大小快照，不设置业务数量上限且不补充未提交文件。
 */
export const createCanvasMaterialDownloadTask = <ThrowOnError extends boolean = false>(
  options: Options<CreateCanvasMaterialDownloadTaskData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateCanvasMaterialDownloadTaskResponse,
    CreateCanvasMaterialDownloadTaskError,
    ThrowOnError
  >({
    ...options,
    url: '/canvases/{canvasId}/materials/download-tasks',
  });
};

/**
 * 查询画布素材打包下载任务
 * 查询 pending、processing、ready、failed 或 expired 状态；ready 状态返回限时下载地址。
 */
export const getCanvasMaterialDownloadTask = <ThrowOnError extends boolean = false>(
  options: Options<GetCanvasMaterialDownloadTaskData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetCanvasMaterialDownloadTaskResponse,
    GetCanvasMaterialDownloadTaskError,
    ThrowOnError
  >({
    ...options,
    url: '/canvases/{canvasId}/materials/download-tasks/{taskId}',
  });
};

/**
 * Extract variables from prompt
 * Unified variable extraction interface that supports two modes:
 * - 'direct': Directly update Canvas variables
 * - 'candidate': Return candidate solutions for user selection
 *
 * This endpoint analyzes natural language prompts and extracts workflow variables
 * based on the context of existing Canvas variables and content.
 *
 */
export const extractVariables = <ThrowOnError extends boolean = false>(
  options: Options<ExtractVariablesData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    ExtractVariablesResponse,
    ExtractVariablesError,
    ThrowOnError
  >({
    ...options,
    url: '/variable-extraction/extract',
  });
};

/**
 * Generate APP publish template
 * Generate a user intent template based on all original prompts and variables in a Canvas.
 * This endpoint analyzes the Canvas content and creates a template with placeholders
 * that can be used for APP publishing and user interaction.
 *
 */
export const generateAppTemplate = <ThrowOnError extends boolean = false>(
  options: Options<GenerateAppTemplateData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    GenerateAppTemplateResponse,
    GenerateAppTemplateError,
    ThrowOnError
  >({
    ...options,
    url: '/variable-extraction/generate-template',
  });
};

/**
 * List MCP servers
 * List all MCP servers for a user
 */
export const listMcpServers = <ThrowOnError extends boolean = false>(
  options?: Options<ListMcpServersData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListMcpServersResponse2,
    ListMcpServersError,
    ThrowOnError
  >({
    ...options,
    url: '/mcp-server/list',
  });
};

/**
 * Create MCP server
 * Create a new MCP server
 */
export const createMcpServer = <ThrowOnError extends boolean = false>(
  options: Options<CreateMcpServerData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateMcpServerResponse,
    CreateMcpServerError,
    ThrowOnError
  >({
    ...options,
    url: '/mcp-server/create',
  });
};

/**
 * Update MCP server
 * Update an existing MCP server
 */
export const updateMcpServer = <ThrowOnError extends boolean = false>(
  options: Options<UpdateMcpServerData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    UpdateMcpServerResponse,
    UpdateMcpServerError,
    ThrowOnError
  >({
    ...options,
    url: '/mcp-server/update',
  });
};

/**
 * Delete MCP server
 * Delete an existing MCP server
 */
export const deleteMcpServer = <ThrowOnError extends boolean = false>(
  options: Options<DeleteMcpServerData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    DeleteMcpServerResponse2,
    DeleteMcpServerError,
    ThrowOnError
  >({
    ...options,
    url: '/mcp-server/delete',
  });
};

/**
 * Validate MCP server
 * Validate MCP server configuration
 */
export const validateMcpServer = <ThrowOnError extends boolean = false>(
  options: Options<ValidateMcpServerData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    ValidateMcpServerResponse2,
    ValidateMcpServerError,
    ThrowOnError
  >({
    ...options,
    url: '/mcp-server/validate',
  });
};

/**
 * List user pages
 * List all pages for a user
 */
export const listPages = <ThrowOnError extends boolean = false>(
  options?: Options<ListPagesData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<ListPagesResponse2, ListPagesError, ThrowOnError>({
    ...options,
    url: '/pages',
  });
};

/**
 * Get page detail
 * Get detail of a specific page
 */
export const getPageDetail = <ThrowOnError extends boolean = false>(
  options: Options<GetPageDetailData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<GetPageDetailResponse, GetPageDetailError, ThrowOnError>({
    ...options,
    url: '/pages/{pageId}',
  });
};

/**
 * Update a page
 * Update a specific page
 */
export const updatePage = <ThrowOnError extends boolean = false>(
  options: Options<UpdatePageData, ThrowOnError>,
) => {
  return (options?.client ?? client).put<UpdatePageResponse2, UpdatePageError, ThrowOnError>({
    ...options,
    url: '/pages/{pageId}',
  });
};

/**
 * Share a page
 * Create a share link for a specific page
 */
export const sharePage = <ThrowOnError extends boolean = false>(
  options: Options<SharePageData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<SharePageResponse2, SharePageError, ThrowOnError>({
    ...options,
    url: '/pages/{pageId}/share',
  });
};

/**
 * Delete a node from a page
 * Remove a specific node from a page
 */
export const deletePageNode = <ThrowOnError extends boolean = false>(
  options: Options<DeletePageNodeData, ThrowOnError>,
) => {
  return (options?.client ?? client).delete<
    DeletePageNodeResponse2,
    DeletePageNodeError,
    ThrowOnError
  >({
    ...options,
    url: '/pages/{pageId}/nodes/{nodeId}',
  });
};

/**
 * Get page by canvas ID
 * Retrieve the page associated with a specific canvas
 */
export const getPageByCanvasId = <ThrowOnError extends boolean = false>(
  options: Options<GetPageByCanvasIdData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetPageByCanvasIdResponse,
    GetPageByCanvasIdError,
    ThrowOnError
  >({
    ...options,
    url: '/pages/canvas/{canvasId}',
  });
};

/**
 * Add nodes to canvas page
 * Add nodes to a page associated with a specific canvas. If no page exists, a new one will be created.
 */
export const addNodesToCanvasPage = <ThrowOnError extends boolean = false>(
  options: Options<AddNodesToCanvasPageData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    AddNodesToCanvasPageResponse,
    AddNodesToCanvasPageError,
    ThrowOnError
  >({
    ...options,
    url: '/pages/canvas/{canvasId}/nodes',
  });
};

/**
 * Get auth config
 * Get auth config
 */
export const getAuthConfig = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<GetAuthConfigResponse, GetAuthConfigError, ThrowOnError>({
    ...options,
    url: '/auth/config',
  });
};

/**
 * Refresh token
 * Refresh token
 */
export const refreshToken = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).post<RefreshTokenResponse, RefreshTokenError, ThrowOnError>({
    ...options,
    url: '/auth/refreshToken',
  });
};

/**
 * Sign up with email
 * Sign up with email
 */
export const emailSignup = <ThrowOnError extends boolean = false>(
  options: Options<EmailSignupData2, ThrowOnError>,
) => {
  return (options?.client ?? client).post<EmailSignupResponse2, EmailSignupError, ThrowOnError>({
    ...options,
    url: '/auth/email/signup',
  });
};

/**
 * Login with email
 * Login with email
 */
export const emailLogin = <ThrowOnError extends boolean = false>(
  options: Options<EmailLoginData2, ThrowOnError>,
) => {
  return (options?.client ?? client).post<EmailLoginResponse2, EmailLoginError, ThrowOnError>({
    ...options,
    url: '/auth/email/login',
  });
};

/**
 * Create verification session
 * Create a verification session
 */
export const createVerification = <ThrowOnError extends boolean = false>(
  options: Options<CreateVerificationData2, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateVerificationResponse2,
    CreateVerificationError,
    ThrowOnError
  >({
    ...options,
    url: '/auth/verification/create',
  });
};

/**
 * Resend verification
 * Resend verification
 */
export const resendVerification = <ThrowOnError extends boolean = false>(
  options: Options<ResendVerificationData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    ResendVerificationResponse,
    ResendVerificationError,
    ThrowOnError
  >({
    ...options,
    url: '/auth/verification/resend',
  });
};

/**
 * Verify authentication session
 * Verify account creation
 */
export const checkVerification = <ThrowOnError extends boolean = false>(
  options: Options<CheckVerificationData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CheckVerificationResponse,
    CheckVerificationError,
    ThrowOnError
  >({
    ...options,
    url: '/auth/verification/check',
  });
};

/**
 * Logout
 * Logout
 */
export const logout = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).post<LogoutResponse, LogoutError, ThrowOnError>({
    ...options,
    url: '/auth/logout',
  });
};

/**
 * Check tool OAuth status
 * Check if user has OAuth authorization for specific provider and scopes
 */
export const checkToolOauthStatus = <ThrowOnError extends boolean = false>(
  options: Options<CheckToolOauthStatusData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    CheckToolOauthStatusResponse,
    CheckToolOauthStatusError,
    ThrowOnError
  >({
    ...options,
    url: '/auth/tool-oauth/status',
  });
};

/**
 * Get collab token
 * Get collab token
 */
export const getCollabToken = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetCollabTokenResponse2,
    GetCollabTokenError,
    ThrowOnError
  >({
    ...options,
    url: '/collab/getToken',
  });
};

/**
 * 获取工作台近期工作流
 * 分页查询当前用户可访问的画布，工作台首页使用该接口展示近期工作流入口。
 */
export const listCanvases = <ThrowOnError extends boolean = false>(
  options?: Options<ListCanvasesData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<ListCanvasesResponse, ListCanvasesError, ThrowOnError>({
    ...options,
    url: '/canvas/list',
  });
};

/**
 * Get canvas detail
 * Get canvas detail
 */
export const getCanvasDetail = <ThrowOnError extends boolean = false>(
  options: Options<GetCanvasDetailData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetCanvasDetailResponse2,
    GetCanvasDetailError,
    ThrowOnError
  >({
    ...options,
    url: '/canvas/detail',
  });
};

/**
 * Get canvas data
 * Get public canvas data without checking user identity
 */
export const getCanvasData = <ThrowOnError extends boolean = false>(
  options: Options<GetCanvasDataData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<GetCanvasDataResponse2, GetCanvasDataError, ThrowOnError>({
    ...options,
    url: '/canvas/data',
  });
};

/**
 * Export canvas
 * Export canvas
 */
export const exportCanvas = <ThrowOnError extends boolean = false>(
  options: Options<ExportCanvasData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<ExportCanvasResponse2, ExportCanvasError, ThrowOnError>({
    ...options,
    url: '/canvas/export',
  });
};

/**
 * Import canvas
 * Import canvas
 */
export const importCanvas = <ThrowOnError extends boolean = false>(
  options: Options<ImportCanvasData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<ImportCanvasResponse, ImportCanvasError, ThrowOnError>({
    ...options,
    ...formDataBodySerializer,
    headers: {
      'Content-Type': null,
      ...options?.headers,
    },
    url: '/canvas/import',
  });
};

/**
 * 创建工作台工作流
 * 为当前用户创建一个新的工作流画布；工作台新建工作流入口使用该接口。
 */
export const createCanvas = <ThrowOnError extends boolean = false>(
  options: Options<CreateCanvasData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<CreateCanvasResponse, CreateCanvasError, ThrowOnError>({
    ...options,
    url: '/canvas/create',
  });
};

/**
 * Duplicate canvas
 * Duplicate an existing canvas
 */
export const duplicateCanvas = <ThrowOnError extends boolean = false>(
  options: Options<DuplicateCanvasData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    DuplicateCanvasResponse,
    DuplicateCanvasError,
    ThrowOnError
  >({
    ...options,
    url: '/canvas/duplicate',
  });
};

/**
 * Update canvas
 * Update an existing canvas
 */
export const updateCanvas = <ThrowOnError extends boolean = false>(
  options: Options<UpdateCanvasData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<UpdateCanvasResponse, UpdateCanvasError, ThrowOnError>({
    ...options,
    url: '/canvas/update',
  });
};

/**
 * Delete canvas
 * Delete an existing canvas
 */
export const deleteCanvas = <ThrowOnError extends boolean = false>(
  options: Options<DeleteCanvasData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<DeleteCanvasResponse, DeleteCanvasError, ThrowOnError>({
    ...options,
    url: '/canvas/delete',
  });
};

/**
 * Auto name canvas
 * Auto name a canvas
 */
export const autoNameCanvas = <ThrowOnError extends boolean = false>(
  options: Options<AutoNameCanvasData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    AutoNameCanvasResponse2,
    AutoNameCanvasError,
    ThrowOnError
  >({
    ...options,
    url: '/canvas/autoName',
  });
};

/**
 * Get canvas state
 * Get canvas state
 */
export const getCanvasState = <ThrowOnError extends boolean = false>(
  options: Options<GetCanvasStateData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetCanvasStateResponse2,
    GetCanvasStateError,
    ThrowOnError
  >({
    ...options,
    url: '/canvas/getState',
  });
};

/**
 * Set canvas state
 * Set canvas state, should only be used in conflict resolution
 */
export const setCanvasState = <ThrowOnError extends boolean = false>(
  options: Options<SetCanvasStateData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    SetCanvasStateResponse,
    SetCanvasStateError,
    ThrowOnError
  >({
    ...options,
    url: '/canvas/setState',
  });
};

/**
 * Get canvas transactions
 * Get canvas transactions
 */
export const getCanvasTransactions = <ThrowOnError extends boolean = false>(
  options: Options<GetCanvasTransactionsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetCanvasTransactionsResponse2,
    GetCanvasTransactionsError,
    ThrowOnError
  >({
    ...options,
    url: '/canvas/getTx',
  });
};

/**
 * Sync canvas state
 * Sync canvas state
 */
export const syncCanvasState = <ThrowOnError extends boolean = false>(
  options: Options<SyncCanvasStateData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    SyncCanvasStateResponse2,
    SyncCanvasStateError,
    ThrowOnError
  >({
    ...options,
    url: '/canvas/syncState',
  });
};

/**
 * Create canvas version
 * Create a new canvas version
 */
export const createCanvasVersion = <ThrowOnError extends boolean = false>(
  options: Options<CreateCanvasVersionData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateCanvasVersionResponse2,
    CreateCanvasVersionError,
    ThrowOnError
  >({
    ...options,
    url: '/canvas/createVersion',
  });
};

/**
 * Get workflow variables
 * Get workflow variables for a canvas
 */
export const getWorkflowVariables = <ThrowOnError extends boolean = false>(
  options: Options<GetWorkflowVariablesData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetWorkflowVariablesResponse2,
    GetWorkflowVariablesError,
    ThrowOnError
  >({
    ...options,
    url: '/canvas/workflow/variables',
  });
};

/**
 * Update workflow variables
 * Update workflow variables for a canvas
 */
export const updateWorkflowVariables = <ThrowOnError extends boolean = false>(
  options: Options<UpdateWorkflowVariablesData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    UpdateWorkflowVariablesResponse2,
    UpdateWorkflowVariablesError,
    ThrowOnError
  >({
    ...options,
    url: '/canvas/workflow/variables',
  });
};

/**
 * List drive files
 * List all drive files
 */
export const listDriveFiles = <ThrowOnError extends boolean = false>(
  options: Options<ListDriveFilesData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListDriveFilesResponse2,
    ListDriveFilesError,
    ThrowOnError
  >({
    ...options,
    url: '/drive/file/list',
  });
};

/**
 * Create drive file
 * Create a new drive file
 */
export const createDriveFile = <ThrowOnError extends boolean = false>(
  options: Options<CreateDriveFileData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateDriveFileResponse,
    CreateDriveFileError,
    ThrowOnError
  >({
    ...options,
    url: '/drive/file/create',
  });
};

/**
 * Batch create drive files
 * Batch create drive files
 */
export const batchCreateDriveFiles = <ThrowOnError extends boolean = false>(
  options: Options<BatchCreateDriveFilesData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    BatchCreateDriveFilesResponse2,
    BatchCreateDriveFilesError,
    ThrowOnError
  >({
    ...options,
    url: '/drive/file/batchCreate',
  });
};

/**
 * Update drive file
 * Update an existing drive file
 */
export const updateDriveFile = <ThrowOnError extends boolean = false>(
  options: Options<UpdateDriveFileData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    UpdateDriveFileResponse,
    UpdateDriveFileError,
    ThrowOnError
  >({
    ...options,
    url: '/drive/file/update',
  });
};

/**
 * Delete drive file
 * Delete an existing drive file
 */
export const deleteDriveFile = <ThrowOnError extends boolean = false>(
  options: Options<DeleteDriveFileData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    DeleteDriveFileResponse,
    DeleteDriveFileError,
    ThrowOnError
  >({
    ...options,
    url: '/drive/file/delete',
  });
};

/**
 * 获取工作台模板推荐
 * 查询公开或当前用户可见的画布模板，工作台首页按分类展示模板推荐。
 */
export const listCanvasTemplates = <ThrowOnError extends boolean = false>(
  options?: Options<ListCanvasTemplatesData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListCanvasTemplatesResponse,
    ListCanvasTemplatesError,
    ThrowOnError
  >({
    ...options,
    url: '/template/list',
  });
};

/**
 * Create canvas template
 * Create a new canvas template
 */
export const createCanvasTemplate = <ThrowOnError extends boolean = false>(
  options: Options<CreateCanvasTemplateData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateCanvasTemplateResponse,
    CreateCanvasTemplateError,
    ThrowOnError
  >({
    ...options,
    url: '/template/create',
  });
};

/**
 * Update canvas template
 * Update an existing canvas template
 */
export const updateCanvasTemplate = <ThrowOnError extends boolean = false>(
  options: Options<UpdateCanvasTemplateData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    UpdateCanvasTemplateResponse,
    UpdateCanvasTemplateError,
    ThrowOnError
  >({
    ...options,
    url: '/template/update',
  });
};

/**
 * 获取工作台模板分类
 * 查询工作台模板推荐使用的全部分类及其多语言名称。
 */
export const listCanvasTemplateCategories = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListCanvasTemplateCategoriesResponse,
    ListCanvasTemplateCategoriesError,
    ThrowOnError
  >({
    ...options,
    url: '/template/category/list',
  });
};

/**
 * List resources
 * List all resources
 */
export const listResources = <ThrowOnError extends boolean = false>(
  options?: Options<ListResourcesData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<ListResourcesResponse, ListResourcesError, ThrowOnError>({
    ...options,
    url: '/knowledge/resource/list',
  });
};

/**
 * Get resource detail
 * Return resource detail along with its document content
 */
export const getResourceDetail = <ThrowOnError extends boolean = false>(
  options: Options<GetResourceDetailData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetResourceDetailResponse2,
    GetResourceDetailError,
    ThrowOnError
  >({
    ...options,
    url: '/knowledge/resource/detail',
  });
};

/**
 * Update resource
 * Update an existing resource
 */
export const updateResource = <ThrowOnError extends boolean = false>(
  options: Options<UpdateResourceData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    UpdateResourceResponse,
    UpdateResourceError,
    ThrowOnError
  >({
    ...options,
    url: '/knowledge/resource/update',
  });
};

/**
 * Create new resource
 * Create a new resource
 */
export const createResource = <ThrowOnError extends boolean = false>(
  options: Options<CreateResourceData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateResourceResponse,
    CreateResourceError,
    ThrowOnError
  >({
    ...options,
    url: '/knowledge/resource/create',
  });
};

/**
 * Create new resource with file upload
 * Create a new resource with file upload in a single request
 */
export const createResourceWithFile = <ThrowOnError extends boolean = false>(
  options: Options<CreateResourceWithFileData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateResourceWithFileResponse,
    CreateResourceWithFileError,
    ThrowOnError
  >({
    ...options,
    ...formDataBodySerializer,
    headers: {
      'Content-Type': null,
      ...options?.headers,
    },
    url: '/knowledge/resource/createWithFile',
  });
};

/**
 * Batch create new resources
 * Batch create a new resource
 */
export const batchCreateResource = <ThrowOnError extends boolean = false>(
  options: Options<BatchCreateResourceData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    BatchCreateResourceResponse2,
    BatchCreateResourceError,
    ThrowOnError
  >({
    ...options,
    url: '/knowledge/resource/batchCreate',
  });
};

/**
 * Reindex resource
 * Reindex an existing resource
 */
export const reindexResource = <ThrowOnError extends boolean = false>(
  options: Options<ReindexResourceData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    ReindexResourceResponse2,
    ReindexResourceError,
    ThrowOnError
  >({
    ...options,
    url: '/knowledge/resource/reindex',
  });
};

/**
 * Delete resource
 * Delete an existing resource
 */
export const deleteResource = <ThrowOnError extends boolean = false>(
  options: Options<DeleteResourceData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    DeleteResourceResponse,
    DeleteResourceError,
    ThrowOnError
  >({
    ...options,
    url: '/knowledge/resource/delete',
  });
};

/**
 * List user documents
 * List all documents for a user
 */
export const listDocuments = <ThrowOnError extends boolean = false>(
  options?: Options<ListDocumentsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<ListDocumentsResponse, ListDocumentsError, ThrowOnError>({
    ...options,
    url: '/knowledge/document/list',
  });
};

/**
 * Get canvas detail
 * Return document detail
 */
export const getDocumentDetail = <ThrowOnError extends boolean = false>(
  options: Options<GetDocumentDetailData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetDocumentDetailResponse2,
    GetDocumentDetailError,
    ThrowOnError
  >({
    ...options,
    url: '/knowledge/document/detail',
  });
};

/**
 * Export document to Markdown, DOCX or PDF format
 * Export a document to Markdown, DOCX or PDF format
 */
export const exportDocument = <ThrowOnError extends boolean = false>(
  options: Options<ExportDocumentData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<ExportDocumentResponse, ExportDocumentError, ThrowOnError>(
    {
      ...options,
      url: '/drive/document/export',
    },
  );
};

/**
 * Start async document export
 * Start an asynchronous document export job using Lambda. Use this for binary files (docx, pdf) that need format conversion.
 */
export const startExportJob = <ThrowOnError extends boolean = false>(
  options: Options<StartExportJobData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    StartExportJobResponse2,
    StartExportJobError,
    ThrowOnError
  >({
    ...options,
    url: '/drive/document/export/async',
  });
};

/**
 * Get export job status
 * Get the status of an async export job
 */
export const getExportJobStatus = <ThrowOnError extends boolean = false>(
  options: Options<GetExportJobStatusData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetExportJobStatusResponse2,
    GetExportJobStatusError,
    ThrowOnError
  >({
    ...options,
    url: '/drive/document/export/job/{jobId}',
  });
};

/**
 * Download export job result
 * Download the result of a completed export job
 */
export const downloadExportJobResult = <ThrowOnError extends boolean = false>(
  options: Options<DownloadExportJobResultData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    DownloadExportJobResultResponse,
    DownloadExportJobResultError,
    ThrowOnError
  >({
    ...options,
    url: '/drive/document/export/job/{jobId}/download',
  });
};

/**
 * Update canvas
 * Update an existing document
 */
export const updateDocument = <ThrowOnError extends boolean = false>(
  options: Options<UpdateDocumentData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    UpdateDocumentResponse,
    UpdateDocumentError,
    ThrowOnError
  >({
    ...options,
    url: '/knowledge/document/update',
  });
};

/**
 * Create new canvas
 * Create a new document
 */
export const createDocument = <ThrowOnError extends boolean = false>(
  options: Options<CreateDocumentData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateDocumentResponse,
    CreateDocumentError,
    ThrowOnError
  >({
    ...options,
    url: '/knowledge/document/create',
  });
};

/**
 * Delete canvas
 * Delete an existing document
 */
export const deleteDocument = <ThrowOnError extends boolean = false>(
  options: Options<DeleteDocumentData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    DeleteDocumentResponse,
    DeleteDocumentError,
    ThrowOnError
  >({
    ...options,
    url: '/knowledge/document/delete',
  });
};

/**
 * Batch update documents
 * Batch update existing documents
 */
export const batchUpdateDocument = <ThrowOnError extends boolean = false>(
  options: Options<BatchUpdateDocumentData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    BatchUpdateDocumentResponse,
    BatchUpdateDocumentError,
    ThrowOnError
  >({
    ...options,
    url: '/knowledge/document/batchUpdate',
  });
};

/**
 * List projects
 * List all projects
 */
export const listProjects = <ThrowOnError extends boolean = false>(
  options?: Options<ListProjectsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<ListProjectsResponse, ListProjectsError, ThrowOnError>({
    ...options,
    url: '/project/list',
  });
};

/**
 * Get project detail
 * Get project detail by project ID
 */
export const getProjectDetail = <ThrowOnError extends boolean = false>(
  options: Options<GetProjectDetailData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetProjectDetailResponse2,
    GetProjectDetailError,
    ThrowOnError
  >({
    ...options,
    url: '/project/detail',
  });
};

/**
 * Create new project
 * Create a new project
 */
export const createProject = <ThrowOnError extends boolean = false>(
  options: Options<CreateProjectData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<CreateProjectResponse, CreateProjectError, ThrowOnError>({
    ...options,
    url: '/project/new',
  });
};

/**
 * Update project
 * Update an existing project
 */
export const updateProject = <ThrowOnError extends boolean = false>(
  options: Options<UpdateProjectData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<UpdateProjectResponse, UpdateProjectError, ThrowOnError>({
    ...options,
    url: '/project/update',
  });
};

/**
 * Update items in project
 * Update items in a project
 */
export const updateProjectItems = <ThrowOnError extends boolean = false>(
  options: Options<UpdateProjectItemsData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    UpdateProjectItemsResponse,
    UpdateProjectItemsError,
    ThrowOnError
  >({
    ...options,
    url: '/project/updateItems',
  });
};

/**
 * Delete project
 * Delete an existing project
 */
export const deleteProject = <ThrowOnError extends boolean = false>(
  options: Options<DeleteProjectData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<DeleteProjectResponse, DeleteProjectError, ThrowOnError>({
    ...options,
    url: '/project/delete',
  });
};

/**
 * Delete items in project
 * Delete items in a project
 */
export const deleteProjectItems = <ThrowOnError extends boolean = false>(
  options: Options<DeleteProjectItemsData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    DeleteProjectItemsResponse,
    DeleteProjectItemsError,
    ThrowOnError
  >({
    ...options,
    url: '/project/deleteItems',
  });
};

/**
 * List code artifacts
 * List all code artifacts
 */
export const listCodeArtifacts = <ThrowOnError extends boolean = false>(
  options?: Options<ListCodeArtifactsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListCodeArtifactsResponse,
    ListCodeArtifactsError,
    ThrowOnError
  >({
    ...options,
    url: '/codeArtifact/list',
  });
};

/**
 * Get code artifact detail
 * Get code artifact detail by artifact ID
 */
export const getCodeArtifactDetail = <ThrowOnError extends boolean = false>(
  options: Options<GetCodeArtifactDetailData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetCodeArtifactDetailResponse2,
    GetCodeArtifactDetailError,
    ThrowOnError
  >({
    ...options,
    url: '/codeArtifact/detail',
  });
};

/**
 * Create code artifact
 * Create new code artifact
 */
export const createCodeArtifact = <ThrowOnError extends boolean = false>(
  options: Options<CreateCodeArtifactData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateCodeArtifactResponse,
    CreateCodeArtifactError,
    ThrowOnError
  >({
    ...options,
    url: '/codeArtifact/new',
  });
};

/**
 * Update code artifact
 * Update code artifact by artifact ID
 */
export const updateCodeArtifact = <ThrowOnError extends boolean = false>(
  options: Options<UpdateCodeArtifactData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    UpdateCodeArtifactResponse,
    UpdateCodeArtifactError,
    ThrowOnError
  >({
    ...options,
    url: '/codeArtifact/update',
  });
};

/**
 * Create share
 * Create new share for canvas
 */
export const createShare = <ThrowOnError extends boolean = false>(
  options: Options<CreateShareData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<CreateShareResponse2, CreateShareError, ThrowOnError>({
    ...options,
    url: '/share/new',
  });
};

/**
 * List shares
 * List all shares
 */
export const listShares = <ThrowOnError extends boolean = false>(
  options?: Options<ListSharesData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<ListSharesResponse, ListSharesError, ThrowOnError>({
    ...options,
    url: '/share/list',
  });
};

/**
 * Delete share
 * Delete an existing share
 */
export const deleteShare = <ThrowOnError extends boolean = false>(
  options: Options<DeleteShareData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<DeleteShareResponse, DeleteShareError, ThrowOnError>({
    ...options,
    url: '/share/delete',
  });
};

/**
 * Duplicate share
 * Duplicate an existing share
 */
export const duplicateShare = <ThrowOnError extends boolean = false>(
  options: Options<DuplicateShareData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    DuplicateShareResponse2,
    DuplicateShareError,
    ThrowOnError
  >({
    ...options,
    url: '/share/duplicate',
  });
};

/**
 * List label classes
 * List all label classes
 */
export const listLabelClasses = <ThrowOnError extends boolean = false>(
  options?: Options<ListLabelClassesData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListLabelClassesResponse2,
    ListLabelClassesError,
    ThrowOnError
  >({
    ...options,
    url: '/label/class/list',
  });
};

/**
 * Create new label class
 * Create a new label class
 */
export const createLabelClass = <ThrowOnError extends boolean = false>(
  options: Options<CreateLabelClassData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateLabelClassResponse,
    CreateLabelClassError,
    ThrowOnError
  >({
    ...options,
    url: '/label/class/new',
  });
};

/**
 * Update label class
 * Update an existing label class
 */
export const updateLabelClass = <ThrowOnError extends boolean = false>(
  options: Options<UpdateLabelClassData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    UpdateLabelClassResponse,
    UpdateLabelClassError,
    ThrowOnError
  >({
    ...options,
    url: '/label/class/update',
  });
};

/**
 * Delete label class
 * Delete an existing label class
 */
export const deleteLabelClass = <ThrowOnError extends boolean = false>(
  options: Options<DeleteLabelClassData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    DeleteLabelClassResponse,
    DeleteLabelClassError,
    ThrowOnError
  >({
    ...options,
    url: '/label/class/delete',
  });
};

/**
 * List labels
 * List all label instances
 */
export const listLabelInstances = <ThrowOnError extends boolean = false>(
  options?: Options<ListLabelInstancesData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListLabelInstancesResponse2,
    ListLabelInstancesError,
    ThrowOnError
  >({
    ...options,
    url: '/label/instance/list',
  });
};

/**
 * Create new label instance
 * Create new label instance
 */
export const createLabelInstance = <ThrowOnError extends boolean = false>(
  options: Options<CreateLabelInstanceData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateLabelInstanceResponse,
    CreateLabelInstanceError,
    ThrowOnError
  >({
    ...options,
    url: '/label/instance/new',
  });
};

/**
 * Update label
 * Update an existing label instance
 */
export const updateLabelInstance = <ThrowOnError extends boolean = false>(
  options: Options<UpdateLabelInstanceData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    UpdateLabelInstanceResponse,
    UpdateLabelInstanceError,
    ThrowOnError
  >({
    ...options,
    url: '/label/instance/update',
  });
};

/**
 * Delete label
 * Delete an existing label
 */
export const deleteLabelInstance = <ThrowOnError extends boolean = false>(
  options: Options<DeleteLabelInstanceData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    DeleteLabelInstanceResponse,
    DeleteLabelInstanceError,
    ThrowOnError
  >({
    ...options,
    url: '/label/instance/delete',
  });
};

/**
 * Get action result
 * Get action result by result ID
 */
export const getActionResult = <ThrowOnError extends boolean = false>(
  options: Options<GetActionResultData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetActionResultResponse2,
    GetActionResultError,
    ThrowOnError
  >({
    ...options,
    url: '/action/result',
  });
};

/**
 * Abort action
 * Abort an action
 */
export const abortAction = <ThrowOnError extends boolean = false>(
  options: Options<AbortActionData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<AbortActionResponse, AbortActionError, ThrowOnError>({
    ...options,
    url: '/action/abort',
  });
};

/**
 * List skills
 * List all skills
 */
export const listSkills = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<ListSkillsResponse, ListSkillsError, ThrowOnError>({
    ...options,
    url: '/skill/list',
  });
};

/**
 * Invoke skill
 * Invoke a skill
 */
export const invokeSkill = <ThrowOnError extends boolean = false>(
  options: Options<InvokeSkillData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<InvokeSkillResponse2, InvokeSkillError, ThrowOnError>({
    ...options,
    url: '/skill/invoke',
  });
};

/**
 * Stream invoke skill
 * Invoke a skill and return SSE stream
 */
export const streamInvokeSkill = <ThrowOnError extends boolean = false>(
  options: Options<StreamInvokeSkillData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    StreamInvokeSkillResponse,
    StreamInvokeSkillError,
    ThrowOnError
  >({
    ...options,
    url: '/skill/streamInvoke',
  });
};

/**
 * List skill instances
 * List skill instances for a user
 */
export const listSkillInstances = <ThrowOnError extends boolean = false>(
  options?: Options<ListSkillInstancesData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListSkillInstancesResponse,
    ListSkillInstancesError,
    ThrowOnError
  >({
    ...options,
    url: '/skill/instance/list',
  });
};

/**
 * Create new skill instance
 * Create a new skill instance for user
 */
export const createSkillInstance = <ThrowOnError extends boolean = false>(
  options: Options<CreateSkillInstanceData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateSkillInstanceResponse2,
    CreateSkillInstanceError,
    ThrowOnError
  >({
    ...options,
    url: '/skill/instance/new',
  });
};

/**
 * Update skill instance
 * Update an existing skill instance
 */
export const updateSkillInstance = <ThrowOnError extends boolean = false>(
  options: Options<UpdateSkillInstanceData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    UpdateSkillInstanceResponse2,
    UpdateSkillInstanceError,
    ThrowOnError
  >({
    ...options,
    url: '/skill/instance/update',
  });
};

/**
 * Pin skill instance
 * Pin an existing skill instance
 */
export const pinSkillInstance = <ThrowOnError extends boolean = false>(
  options: Options<PinSkillInstanceData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    PinSkillInstanceResponse,
    PinSkillInstanceError,
    ThrowOnError
  >({
    ...options,
    url: '/skill/instance/pin',
  });
};

/**
 * Unpin skill instance
 * Unpin an existing skill instance
 */
export const unpinSkillInstance = <ThrowOnError extends boolean = false>(
  options: Options<UnpinSkillInstanceData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    UnpinSkillInstanceResponse,
    UnpinSkillInstanceError,
    ThrowOnError
  >({
    ...options,
    url: '/skill/instance/unpin',
  });
};

/**
 * Delete skill instance
 * Delete an existing skill instance
 */
export const deleteSkillInstance = <ThrowOnError extends boolean = false>(
  options: Options<DeleteSkillInstanceData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    DeleteSkillInstanceResponse,
    DeleteSkillInstanceError,
    ThrowOnError
  >({
    ...options,
    url: '/skill/instance/delete',
  });
};

/**
 * List skill triggers
 * List all skill triggers
 */
export const listSkillTriggers = <ThrowOnError extends boolean = false>(
  options?: Options<ListSkillTriggersData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListSkillTriggersResponse,
    ListSkillTriggersError,
    ThrowOnError
  >({
    ...options,
    url: '/skill/trigger/list',
  });
};

/**
 * Create new trigger
 * Create a new trigger
 */
export const createSkillTrigger = <ThrowOnError extends boolean = false>(
  options: Options<CreateSkillTriggerData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateSkillTriggerResponse2,
    CreateSkillTriggerError,
    ThrowOnError
  >({
    ...options,
    url: '/skill/trigger/new',
  });
};

/**
 * Update trigger
 * Update an existing trigger
 */
export const updateSkillTrigger = <ThrowOnError extends boolean = false>(
  options: Options<UpdateSkillTriggerData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    UpdateSkillTriggerResponse2,
    UpdateSkillTriggerError,
    ThrowOnError
  >({
    ...options,
    url: '/skill/trigger/update',
  });
};

/**
 * Delete trigger
 * Delete an existing trigger
 */
export const deleteSkillTrigger = <ThrowOnError extends boolean = false>(
  options: Options<DeleteSkillTriggerData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    DeleteSkillTriggerResponse,
    DeleteSkillTriggerError,
    ThrowOnError
  >({
    ...options,
    url: '/skill/trigger/delete',
  });
};

/**
 * Generate multimedia content
 * Generate image, video or audio based on the given prompt
 */
export const generateMedia = <ThrowOnError extends boolean = false>(
  options: Options<GenerateMediaData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<GenerateMediaResponse, GenerateMediaError, ThrowOnError>({
    ...options,
    url: '/media/generate',
  });
};

/**
 * Create new pilot session
 * Create a new pilot session
 */
export const createPilotSession = <ThrowOnError extends boolean = false>(
  options: Options<CreatePilotSessionData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreatePilotSessionResponse,
    CreatePilotSessionError,
    ThrowOnError
  >({
    ...options,
    url: '/pilot/session/new',
  });
};

/**
 * Update pilot session
 * Update an existing pilot session
 */
export const updatePilotSession = <ThrowOnError extends boolean = false>(
  options: Options<UpdatePilotSessionData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    UpdatePilotSessionResponse,
    UpdatePilotSessionError,
    ThrowOnError
  >({
    ...options,
    url: '/pilot/session/update',
  });
};

/**
 * List pilot sessions
 * List all pilot sessions
 */
export const listPilotSessions = <ThrowOnError extends boolean = false>(
  options?: Options<ListPilotSessionsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListPilotSessionsResponse2,
    ListPilotSessionsError,
    ThrowOnError
  >({
    ...options,
    url: '/pilot/session/list',
  });
};

/**
 * Get pilot session detail
 * Get detail for a pilot session
 */
export const getPilotSessionDetail = <ThrowOnError extends boolean = false>(
  options: Options<GetPilotSessionDetailData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetPilotSessionDetailResponse2,
    GetPilotSessionDetailError,
    ThrowOnError
  >({
    ...options,
    url: '/pilot/session/detail',
  });
};

/**
 * Recover pilot session
 * Recover a failed pilot session by retrying failed steps. Can recover all failed steps or specific steps.
 */
export const recoverPilotSession = <ThrowOnError extends boolean = false>(
  options: Options<RecoverPilotSessionData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    RecoverPilotSessionResponse,
    RecoverPilotSessionError,
    ThrowOnError
  >({
    ...options,
    url: '/pilot/session/recover',
  });
};

/**
 * List copilot sessions
 * List all copilot sessions
 */
export const listCopilotSessions = <ThrowOnError extends boolean = false>(
  options?: Options<ListCopilotSessionsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListCopilotSessionsResponse2,
    ListCopilotSessionsError,
    ThrowOnError
  >({
    ...options,
    url: '/copilot/session/list',
  });
};

/**
 * 删除 Copilot 会话
 * 软删除当前用户的一个 Copilot 会话，用于 AI 工作台删除历史任务；不删除已生成的工作流
 */
export const deleteCopilotSession = <ThrowOnError extends boolean = false>(
  options: Options<DeleteCopilotSessionData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    DeleteCopilotSessionResponse,
    DeleteCopilotSessionError,
    ThrowOnError
  >({
    ...options,
    url: '/copilot/session/delete',
  });
};

/**
 * 将工作台会话的工作流计划落到画布
 * AI 工作台专用。读取指定结果中生成或修改的工作流计划：会话尚未绑定画布时新建画布并绑定， 已绑定时按最新计划覆盖该画布（保留开始节点），同时把会话中上传的附件转挂到该画布。 同一会话多次调用始终落到同一画布。
 */
export const materializeCopilotSession = <ThrowOnError extends boolean = false>(
  options: Options<MaterializeCopilotSessionData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    MaterializeCopilotSessionResponse2,
    MaterializeCopilotSessionError,
    ThrowOnError
  >({
    ...options,
    url: '/copilot/session/materialize',
  });
};

/**
 * Get copilot session detail
 * Get detail for a copilot session
 */
export const getCopilotSessionDetail = <ThrowOnError extends boolean = false>(
  options: Options<GetCopilotSessionDetailData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetCopilotSessionDetailResponse2,
    GetCopilotSessionDetailError,
    ThrowOnError
  >({
    ...options,
    url: '/copilot/session/detail',
  });
};

/**
 * Restart a completed workflow node or one account publishing task
 * Reuses the original execution inputs and upstream outputs. An optional accountId restarts only that account in a socialPublish node and preserves other account results. Account tasks can restart while other tasks are running. Latest canvas task prompts and settings are used. Omitting accountId restarts the entire node. Requires ownership of the execution.
 */
export const restartWorkflowNode = <ThrowOnError extends boolean = false>(
  options: Options<RestartWorkflowNodeData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    RestartWorkflowNodeResponse,
    RestartWorkflowNodeError,
    ThrowOnError
  >({
    ...options,
    url: '/cli/workflow/run/{runId}/node/{nodeId}/restart',
  });
};

/**
 * Stop one publishing account task
 * Stops only the selected account. Other tasks continue and keep the node executing.
 */
export const stopPublishTask = <ThrowOnError extends boolean = false>(
  options: Options<StopPublishTaskData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    StopPublishTaskResponse,
    StopPublishTaskError,
    ThrowOnError
  >({
    ...options,
    url: '/cli/workflow/run/{runId}/node/{nodeId}/stop',
  });
};

/**
 * Initialize workflow execution
 * Initialize a new workflow execution for a canvas
 */
export const initializeWorkflow = <ThrowOnError extends boolean = false>(
  options: Options<InitializeWorkflowData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    InitializeWorkflowResponse2,
    InitializeWorkflowError,
    ThrowOnError
  >({
    ...options,
    url: '/workflow/initialize',
  });
};

/**
 * Abort workflow execution
 * Abort a running workflow execution
 */
export const abortWorkflow = <ThrowOnError extends boolean = false>(
  options: Options<AbortWorkflowData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<AbortWorkflowResponse, AbortWorkflowError, ThrowOnError>({
    ...options,
    url: '/workflow/abort',
  });
};

/**
 * List workflow executions
 * List all workflow executions
 */
export const listWorkflowExecutions = <ThrowOnError extends boolean = false>(
  options?: Options<ListWorkflowExecutionsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListWorkflowExecutionsResponse2,
    ListWorkflowExecutionsError,
    ThrowOnError
  >({
    ...options,
    url: '/workflow/list',
  });
};

/**
 * Get workflow detail
 * Get detail for a workflow execution
 */
export const getWorkflowDetail = <ThrowOnError extends boolean = false>(
  options: Options<GetWorkflowDetailData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetWorkflowDetailResponse2,
    GetWorkflowDetailError,
    ThrowOnError
  >({
    ...options,
    url: '/workflow/detail',
  });
};

/**
 * Get workflow plan detail
 * Get detail for a workflow plan
 */
export const getWorkflowPlanDetail = <ThrowOnError extends boolean = false>(
  options: Options<GetWorkflowPlanDetailData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetWorkflowPlanDetailResponse2,
    GetWorkflowPlanDetailError,
    ThrowOnError
  >({
    ...options,
    url: '/workflow/plan/detail',
  });
};

/**
 * Create new workflow app
 * Create a new workflow app
 */
export const createWorkflowApp = <ThrowOnError extends boolean = false>(
  options: Options<CreateWorkflowAppData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateWorkflowAppResponse2,
    CreateWorkflowAppError,
    ThrowOnError
  >({
    ...options,
    url: '/workflow-app/new',
  });
};

/**
 * Delete workflow app
 * Delete a workflow app
 */
export const deleteWorkflowApp = <ThrowOnError extends boolean = false>(
  options: Options<DeleteWorkflowAppData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    DeleteWorkflowAppResponse,
    DeleteWorkflowAppError,
    ThrowOnError
  >({
    ...options,
    url: '/workflow-app/delete',
  });
};

/**
 * Get workflow app detail
 * Get detail for a workflow app
 */
export const getWorkflowAppDetail = <ThrowOnError extends boolean = false>(
  options: Options<GetWorkflowAppDetailData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetWorkflowAppDetailResponse2,
    GetWorkflowAppDetailError,
    ThrowOnError
  >({
    ...options,
    url: '/workflow-app/detail',
  });
};

/**
 * Execute workflow app
 * Execute a workflow app
 */
export const executeWorkflowApp = <ThrowOnError extends boolean = false>(
  options: Options<ExecuteWorkflowAppData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    ExecuteWorkflowAppResponse2,
    ExecuteWorkflowAppError,
    ThrowOnError
  >({
    ...options,
    url: '/workflow-app/execute',
  });
};

/**
 * List workflow apps
 * List workflow apps for a user, optionally filtered by canvasId
 */
export const listWorkflowApps = <ThrowOnError extends boolean = false>(
  options?: Options<ListWorkflowAppsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListWorkflowAppsResponse2,
    ListWorkflowAppsError,
    ThrowOnError
  >({
    ...options,
    url: '/workflow-app/list',
  });
};

/**
 * Get template generation status
 * Get template generation status for a workflow app
 */
export const getTemplateGenerationStatus = <ThrowOnError extends boolean = false>(
  options: Options<GetTemplateGenerationStatusData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetTemplateGenerationStatusResponse2,
    GetTemplateGenerationStatusError,
    ThrowOnError
  >({
    ...options,
    url: '/workflow-app/template-status',
  });
};

/**
 * Create workflow schedule
 * Create a new schedule for workflow execution
 */
export const createSchedule = <ThrowOnError extends boolean = false>(
  options: Options<CreateScheduleData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateScheduleResponse2,
    CreateScheduleError,
    ThrowOnError
  >({
    ...options,
    url: '/schedule/create',
  });
};

/**
 * Update workflow schedule
 * Update an existing workflow schedule
 */
export const updateSchedule = <ThrowOnError extends boolean = false>(
  options: Options<UpdateScheduleData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    UpdateScheduleResponse2,
    UpdateScheduleError,
    ThrowOnError
  >({
    ...options,
    url: '/schedule/update',
  });
};

/**
 * Delete workflow schedule
 * Delete an existing workflow schedule
 */
export const deleteSchedule = <ThrowOnError extends boolean = false>(
  options: Options<DeleteScheduleData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    DeleteScheduleResponse2,
    DeleteScheduleError,
    ThrowOnError
  >({
    ...options,
    url: '/schedule/delete',
  });
};

/**
 * List workflow schedules
 * Get list of workflow schedules for a canvas
 */
export const listSchedules = <ThrowOnError extends boolean = false>(
  options: Options<ListSchedulesData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<ListSchedulesResponse2, ListSchedulesError, ThrowOnError>(
    {
      ...options,
      url: '/schedule/list',
    },
  );
};

/**
 * Get schedule detail
 * Get detailed information about a specific schedule
 */
export const getScheduleDetail = <ThrowOnError extends boolean = false>(
  options: Options<GetScheduleDetailData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    GetScheduleDetailResponse2,
    GetScheduleDetailError,
    ThrowOnError
  >({
    ...options,
    url: '/schedule/detail',
  });
};

/**
 * Get schedule records
 * Get execution records for a specific schedule
 */
export const getScheduleRecords = <ThrowOnError extends boolean = false>(
  options: Options<GetScheduleRecordsData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    GetScheduleRecordsResponse2,
    GetScheduleRecordsError,
    ThrowOnError
  >({
    ...options,
    url: '/schedule/records',
  });
};

/**
 * List all schedule records
 * List all schedule execution records with filtering options
 */
export const listAllScheduleRecords = <ThrowOnError extends boolean = false>(
  options: Options<ListAllScheduleRecordsData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    ListAllScheduleRecordsResponse2,
    ListAllScheduleRecordsError,
    ThrowOnError
  >({
    ...options,
    url: '/schedule/records/list',
  });
};

/**
 * Get available tools
 * Get list of tools used in schedule executions
 */
export const getAvailableTools = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    GetAvailableToolsResponse2,
    GetAvailableToolsError,
    ThrowOnError
  >({
    ...options,
    url: '/schedule/records/tools',
  });
};

/**
 * Get schedule record detail
 * Get detailed information about a specific schedule execution record
 */
export const getScheduleRecordDetail = <ThrowOnError extends boolean = false>(
  options: Options<GetScheduleRecordDetailData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    GetScheduleRecordDetailResponse2,
    GetScheduleRecordDetailError,
    ThrowOnError
  >({
    ...options,
    url: '/schedule/record/detail',
  });
};

/**
 * Get record snapshot
 * Get the canvas snapshot for a schedule execution record
 */
export const getRecordSnapshot = <ThrowOnError extends boolean = false>(
  options: Options<GetRecordSnapshotData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    GetRecordSnapshotResponse2,
    GetRecordSnapshotError,
    ThrowOnError
  >({
    ...options,
    url: '/schedule/record/snapshot',
  });
};

/**
 * Trigger schedule manually
 * Manually trigger a schedule execution
 */
export const triggerScheduleManually = <ThrowOnError extends boolean = false>(
  options: Options<TriggerScheduleManuallyData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    TriggerScheduleManuallyResponse2,
    TriggerScheduleManuallyError,
    ThrowOnError
  >({
    ...options,
    url: '/schedule/trigger',
  });
};

/**
 * Retry schedule record
 * Retry a failed schedule execution record
 */
export const retryScheduleRecord = <ThrowOnError extends boolean = false>(
  options: Options<RetryScheduleRecordData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    RetryScheduleRecordResponse2,
    RetryScheduleRecordError,
    ThrowOnError
  >({
    ...options,
    url: '/schedule/record/retry',
  });
};

/**
 * Create AIMfly API key
 */
export const createCliApiKey = <ThrowOnError extends boolean = false>(
  options: Options<CreateCliApiKeyData2, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateCliApiKeyResponse2,
    CreateCliApiKeyError,
    ThrowOnError
  >({
    ...options,
    url: '/auth/cli/api-key',
  });
};

/**
 * List AIMfly API keys
 */
export const listCliApiKeys = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListCliApiKeysResponse2,
    ListCliApiKeysError,
    ThrowOnError
  >({
    ...options,
    url: '/auth/cli/api-key',
  });
};

/**
 * Rename AIMfly API key
 */
export const updateCliApiKey = <ThrowOnError extends boolean = false>(
  options: Options<UpdateCliApiKeyData, ThrowOnError>,
) => {
  return (options?.client ?? client).patch<
    UpdateCliApiKeyResponse,
    UpdateCliApiKeyError,
    ThrowOnError
  >({
    ...options,
    url: '/auth/cli/api-key/{keyId}',
  });
};

/**
 * Revoke AIMfly API key
 */
export const revokeCliApiKey = <ThrowOnError extends boolean = false>(
  options: Options<RevokeCliApiKeyData, ThrowOnError>,
) => {
  return (options?.client ?? client).delete<
    RevokeCliApiKeyResponse,
    RevokeCliApiKeyError,
    ThrowOnError
  >({
    ...options,
    url: '/auth/cli/api-key/{keyId}',
  });
};

/**
 * Get API output configuration
 */
export const getOpenapiConfig = <ThrowOnError extends boolean = false>(
  options: Options<GetOpenapiConfigData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetOpenapiConfigResponse,
    GetOpenapiConfigError,
    ThrowOnError
  >({
    ...options,
    url: '/openapi/config',
  });
};

/**
 * Update API output configuration
 */
export const updateOpenapiConfig = <ThrowOnError extends boolean = false>(
  options: Options<UpdateOpenapiConfigData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    UpdateOpenapiConfigResponse,
    UpdateOpenapiConfigError,
    ThrowOnError
  >({
    ...options,
    url: '/openapi/config',
  });
};

/**
 * Upload files for workflow variables
 */
export const uploadOpenapiFiles = <ThrowOnError extends boolean = false>(
  options: Options<UploadOpenapiFilesData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    UploadOpenapiFilesResponse,
    UploadOpenapiFilesError,
    ThrowOnError
  >({
    ...options,
    ...formDataBodySerializer,
    headers: {
      'Content-Type': null,
      ...options?.headers,
    },
    url: '/openapi/files/upload',
  });
};

/**
 * Search workflows via API key
 */
export const searchWorkflowsViaApi = <ThrowOnError extends boolean = false>(
  options?: Options<SearchWorkflowsViaApiData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    SearchWorkflowsViaApiResponse,
    SearchWorkflowsViaApiError,
    ThrowOnError
  >({
    ...options,
    url: '/openapi/workflows',
  });
};

/**
 * Get workflow detail via API key
 */
export const getWorkflowDetailViaApi = <ThrowOnError extends boolean = false>(
  options: Options<GetWorkflowDetailViaApiData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetWorkflowDetailViaApiResponse,
    GetWorkflowDetailViaApiError,
    ThrowOnError
  >({
    ...options,
    url: '/openapi/workflows/{canvasId}',
  });
};

/**
 * Run workflow and return execution ID
 */
export const runWorkflowViaApi = <ThrowOnError extends boolean = false>(
  options: Options<RunWorkflowViaApiData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    RunWorkflowViaApiResponse,
    RunWorkflowViaApiError,
    ThrowOnError
  >({
    ...options,
    url: '/openapi/workflow/{canvasId}/run',
  });
};

/**
 * Generate a workflow plan with Copilot
 */
export const generateWorkflowViaCopilot = <ThrowOnError extends boolean = false>(
  options: Options<GenerateWorkflowViaCopilotData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    GenerateWorkflowViaCopilotResponse,
    GenerateWorkflowViaCopilotError,
    ThrowOnError
  >({
    ...options,
    url: '/openapi/copilot/workflow/generate',
  });
};

/**
 * Get workflow execution status
 */
export const getWorkflowStatusViaApi = <ThrowOnError extends boolean = false>(
  options: Options<GetWorkflowStatusViaApiData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetWorkflowStatusViaApiResponse2,
    GetWorkflowStatusViaApiError,
    ThrowOnError
  >({
    ...options,
    url: '/openapi/workflow/{executionId}/status',
  });
};

/**
 * Get workflow execution output
 */
export const getWorkflowOutput = <ThrowOnError extends boolean = false>(
  options: Options<GetWorkflowOutputData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetWorkflowOutputResponse2,
    GetWorkflowOutputError,
    ThrowOnError
  >({
    ...options,
    url: '/openapi/workflow/{executionId}/output',
  });
};

/**
 * Abort workflow execution
 */
export const abortWorkflowViaApi = <ThrowOnError extends boolean = false>(
  options: Options<AbortWorkflowViaApiData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    AbortWorkflowViaApiResponse,
    AbortWorkflowViaApiError,
    ThrowOnError
  >({
    ...options,
    url: '/openapi/workflow/{executionId}/abort',
  });
};

/**
 * Get user settings
 * Return settings for current user
 */
export const getSettings = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<GetSettingsResponse, GetSettingsError, ThrowOnError>({
    ...options,
    url: '/user/settings',
  });
};

/**
 * Update user settings
 * Update settings for current user
 */
export const updateSettings = <ThrowOnError extends boolean = false>(
  options: Options<UpdateSettingsData, ThrowOnError>,
) => {
  return (options?.client ?? client).put<UpdateSettingsResponse, UpdateSettingsError, ThrowOnError>(
    {
      ...options,
      url: '/user/settings',
    },
  );
};

/**
 * Check settings field
 * Given a settings field, check if the given value is valid
 */
export const checkSettingsField = <ThrowOnError extends boolean = false>(
  options: Options<CheckSettingsFieldData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    CheckSettingsFieldResponse2,
    CheckSettingsFieldError,
    ThrowOnError
  >({
    ...options,
    url: '/user/checkSettingsField',
  });
};

/**
 * Get form definition
 * Get form definition
 */
export const getFormDefinition = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetFormDefinitionResponse2,
    GetFormDefinitionError,
    ThrowOnError
  >({
    ...options,
    url: '/form/definition',
  });
};

/**
 * Submit form
 * Submit a form
 */
export const submitForm = <ThrowOnError extends boolean = false>(
  options: Options<SubmitFormData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<SubmitFormResponse, SubmitFormError, ThrowOnError>({
    ...options,
    url: '/form/submission',
  });
};

/**
 * Check if user has filled the form
 * Check if user has filled the form
 */
export const hasFilledForm = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<HasFilledFormResponse2, HasFilledFormError, ThrowOnError>({
    ...options,
    url: '/form/hasFilledForm',
  });
};

/**
 * Get credit recharge
 * Get credit recharge
 */
export const getCreditRecharge = <ThrowOnError extends boolean = false>(
  options?: Options<GetCreditRechargeData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetCreditRechargeResponse2,
    GetCreditRechargeError,
    ThrowOnError
  >({
    ...options,
    url: '/credit/recharge',
  });
};

/**
 * Get credit usage
 * Get credit usage
 */
export const getCreditUsage = <ThrowOnError extends boolean = false>(
  options?: Options<GetCreditUsageData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetCreditUsageResponse2,
    GetCreditUsageError,
    ThrowOnError
  >({
    ...options,
    url: '/credit/usage',
  });
};

/**
 * Get credit balance
 * Get credit balance
 */
export const getCreditBalance = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetCreditBalanceResponse,
    GetCreditBalanceError,
    ThrowOnError
  >({
    ...options,
    url: '/credit/balance',
  });
};

/**
 * Get credit usage by result ID
 * Get credit usage by result ID
 */
export const getCreditUsageByResultId = <ThrowOnError extends boolean = false>(
  options: Options<GetCreditUsageByResultIdData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetCreditUsageByResultIdResponse2,
    GetCreditUsageByResultIdError,
    ThrowOnError
  >({
    ...options,
    url: '/credit/result',
  });
};

/**
 * Get credit usage by execution ID
 * Get credit usage by execution ID
 */
export const getCreditUsageByExecutionId = <ThrowOnError extends boolean = false>(
  options: Options<GetCreditUsageByExecutionIdData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetCreditUsageByExecutionIdResponse2,
    GetCreditUsageByExecutionIdError,
    ThrowOnError
  >({
    ...options,
    url: '/credit/execution',
  });
};

/**
 * Get credit usage by canvas ID
 * Get credit usage by canvas ID
 */
export const getCreditUsageByCanvasId = <ThrowOnError extends boolean = false>(
  options: Options<GetCreditUsageByCanvasIdData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetCreditUsageByCanvasIdResponse2,
    GetCreditUsageByCanvasIdError,
    ThrowOnError
  >({
    ...options,
    url: '/credit/canvas',
  });
};

/**
 * List invitation codes
 * List all invitation codes
 */
export const listInvitationCodes = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListInvitationCodesResponse2,
    ListInvitationCodesError,
    ThrowOnError
  >({
    ...options,
    url: '/invitation/list',
  });
};

/**
 * Activate invitation code
 * Activate an invitation code
 */
export const activateInvitationCode = <ThrowOnError extends boolean = false>(
  options: Options<ActivateInvitationCodeData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    ActivateInvitationCodeResponse,
    ActivateInvitationCodeError,
    ThrowOnError
  >({
    ...options,
    url: '/invitation/activate',
  });
};

/**
 * Check if user has been invited
 * Check if user has been invited
 */
export const hasBeenInvited = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    HasBeenInvitedResponse2,
    HasBeenInvitedError,
    ThrowOnError
  >({
    ...options,
    url: '/invitation/invited',
  });
};

/**
 * Get subscription plans
 * Get subscription plans
 */
export const getSubscriptionPlans = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetSubscriptionPlansResponse2,
    GetSubscriptionPlansError,
    ThrowOnError
  >({
    ...options,
    url: '/subscription/plans',
  });
};

/**
 * Get subscription usage
 * Get subscription usage
 */
export const getSubscriptionUsage = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetSubscriptionUsageResponse2,
    GetSubscriptionUsageError,
    ThrowOnError
  >({
    ...options,
    url: '/subscription/usage',
  });
};

/**
 * List models
 * List all available models
 */
export const listModels = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<ListModelsResponse2, ListModelsError, ThrowOnError>({
    ...options,
    url: '/subscription/modelList',
  });
};

/**
 * Create checkout session
 * Create a checkout session
 */
export const createCheckoutSession = <ThrowOnError extends boolean = false>(
  options: Options<CreateCheckoutSessionData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateCheckoutSessionResponse2,
    CreateCheckoutSessionError,
    ThrowOnError
  >({
    ...options,
    url: '/subscription/createCheckoutSession',
  });
};

/**
 * Create checkout session
 * Create a checkout session
 */
export const createCreditPackCheckoutSession = <ThrowOnError extends boolean = false>(
  options: Options<CreateCreditPackCheckoutSessionData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateCreditPackCheckoutSessionResponse,
    CreateCreditPackCheckoutSessionError,
    ThrowOnError
  >({
    ...options,
    url: '/subscription/createCreditPackCheckoutSession',
  });
};

/**
 * Create portal session
 * Create a portal session
 */
export const createPortalSession = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreatePortalSessionResponse2,
    CreatePortalSessionError,
    ThrowOnError
  >({
    ...options,
    url: '/subscription/createPortalSession',
  });
};

/**
 * Create payment order
 * Create a payment order for external payment system
 */
export const createPayOrder = <ThrowOnError extends boolean = false>(
  options: Options<CreatePayOrderData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreatePayOrderResponse2,
    CreatePayOrderError,
    ThrowOnError
  >({
    ...options,
    url: '/subscription/createPayOrder',
  });
};

/**
 * Get payment order
 * Get payment order details by order ID
 */
export const getPayOrder = <ThrowOnError extends boolean = false>(
  options: Options<GetPayOrderData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<GetPayOrderResponse2, GetPayOrderError, ThrowOnError>({
    ...options,
    url: '/subscription/payOrder/{payOrderId}',
  });
};

/**
 * Search
 * Search for canvases, resources, documents, etc.
 */
export const search = <ThrowOnError extends boolean = false>(
  options: Options<SearchData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<SearchResponse2, SearchError, ThrowOnError>({
    ...options,
    url: '/search',
  });
};

/**
 * Multilingual Web Search
 * Search web content across multiple languages
 */
export const multiLingualWebSearch = <ThrowOnError extends boolean = false>(
  options: Options<MultiLingualWebSearchData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    MultiLingualWebSearchResponse2,
    MultiLingualWebSearchError,
    ThrowOnError
  >({
    ...options,
    url: '/search/multilingualSearch',
  });
};

/**
 * 获取模型配置选项
 * 一次返回模型管理页面需要的全部选项数据：模型服务商目录及其可选模型、自定义配置支持的 API 格式、模型类型下拉项，以及本版本已实现运行时适配的媒体生成协议。服务商目录按全站所有用户的使用频率实时排序：先比近 30 天该服务商下模型的调用次数，再比通过该服务商添加过的模型数（含已删除），再比最近添加时间；未使用过的服务商保持目录默认顺序。
 */
export const getModelOptions = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetModelOptionsResponse,
    GetModelOptionsError,
    ThrowOnError
  >({
    ...options,
    url: '/model/options',
  });
};

/**
 * 列出可管理的模型
 * 返回内置模型与当前用户自己添加的模型；内置模型只可查看，不能修改或删除。多个筛选条件同时生效。
 */
export const listManagedModels = <ThrowOnError extends boolean = false>(
  options?: Options<ListManagedModelsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListManagedModelsResponse2,
    ListManagedModelsError,
    ThrowOnError
  >({
    ...options,
    url: '/model/list',
  });
};

/**
 * 添加模型
 * 按 sourceType 走两条路径：provider 从服务商目录选择，custom 自行填写服务地址与 API 格式。
 * 落库前必做连通性测试，语言、视觉、多模态类发一次最小对话请求，图片和视频类改为请求模型列表；测试不通过不写入任何数据。
 * modelType 是唯一来源，后端据此派生 category 与 capabilities。本版本未实现适配器的媒体生成协议会被直接拒绝。
 */
export const createManagedModel = <ThrowOnError extends boolean = false>(
  options: Options<CreateManagedModelData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateManagedModelResponse,
    CreateManagedModelError,
    ThrowOnError
  >({
    ...options,
    url: '/model/create',
  });
};

/**
 * 修改模型
 * 只能修改当前用户自己添加的模型。只改上下文长度或最大输出时不重测连通性；改动模型 ID、服务地址、API 格式或密钥会重新测试。
 * 不传 apiKey 表示沿用已保存的密钥。修改 modelType 会同步迁移 category 与 capabilities。
 */
export const updateManagedModel = <ThrowOnError extends boolean = false>(
  options: Options<UpdateManagedModelData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    UpdateManagedModelResponse,
    UpdateManagedModelError,
    ThrowOnError
  >({
    ...options,
    url: '/model/update',
  });
};

/**
 * 启用或停用模型
 * 只切换启用状态，不做连通性测试；停用后该模型不再进入各处模型下拉与工作流计划。仅支持当前用户自己添加的模型。
 */
export const updateManagedModelStatus = <ThrowOnError extends boolean = false>(
  options: Options<UpdateManagedModelStatusData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    UpdateManagedModelStatusResponse,
    UpdateManagedModelStatusError,
    ThrowOnError
  >({
    ...options,
    url: '/model/update-status',
  });
};

/**
 * 删除模型
 * 软删除当前用户自己添加的模型；该模型是其服务商下最后一个模型时，一并软删对应服务商记录。已被用户默认模型引用时拒绝删除。
 */
export const deleteManagedModel = <ThrowOnError extends boolean = false>(
  options: Options<DeleteManagedModelData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    DeleteManagedModelResponse,
    DeleteManagedModelError,
    ThrowOnError
  >({
    ...options,
    url: '/model/delete',
  });
};

/**
 * @deprecated
 * List providers
 * List all available providers
 */
export const listProviders = <ThrowOnError extends boolean = false>(
  options?: Options<ListProvidersData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<ListProvidersResponse2, ListProvidersError, ThrowOnError>({
    ...options,
    url: '/provider/list',
  });
};

/**
 * @deprecated
 * Create provider
 * Create a new provider
 */
export const createProvider = <ThrowOnError extends boolean = false>(
  options: Options<CreateProviderData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateProviderResponse,
    CreateProviderError,
    ThrowOnError
  >({
    ...options,
    url: '/provider/create',
  });
};

/**
 * @deprecated
 * Update provider
 * Update an existing provider
 */
export const updateProvider = <ThrowOnError extends boolean = false>(
  options: Options<UpdateProviderData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    UpdateProviderResponse,
    UpdateProviderError,
    ThrowOnError
  >({
    ...options,
    url: '/provider/update',
  });
};

/**
 * @deprecated
 * Delete provider
 * Delete an existing provider
 */
export const deleteProvider = <ThrowOnError extends boolean = false>(
  options: Options<DeleteProviderData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    DeleteProviderResponse,
    DeleteProviderError,
    ThrowOnError
  >({
    ...options,
    url: '/provider/delete',
  });
};

/**
 * @deprecated
 * Test provider connection
 * Test provider API connection and availability
 */
export const testProviderConnection = <ThrowOnError extends boolean = false>(
  options: Options<TestProviderConnectionData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    TestProviderConnectionResponse2,
    TestProviderConnectionError,
    ThrowOnError
  >({
    ...options,
    url: '/provider/test-connection',
  });
};

/**
 * @deprecated
 * List provider items
 * List all available provider items
 */
export const listProviderItems = <ThrowOnError extends boolean = false>(
  options?: Options<ListProviderItemsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListProviderItemsResponse2,
    ListProviderItemsError,
    ThrowOnError
  >({
    ...options,
    url: '/provider/item/list',
  });
};

/**
 * @deprecated
 * List provider item options
 * List all available provider item options for a given provider
 */
export const listProviderItemOptions = <ThrowOnError extends boolean = false>(
  options: Options<ListProviderItemOptionsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListProviderItemOptionsResponse2,
    ListProviderItemOptionsError,
    ThrowOnError
  >({
    ...options,
    url: '/provider/item/option/list',
  });
};

/**
 * @deprecated
 * Create model item
 * Create a new model item
 */
export const createProviderItem = <ThrowOnError extends boolean = false>(
  options: Options<CreateProviderItemData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateProviderItemResponse,
    CreateProviderItemError,
    ThrowOnError
  >({
    ...options,
    url: '/provider/item/create',
  });
};

/**
 * @deprecated
 * Batch create model items
 * Batch create model items
 */
export const batchCreateProviderItems = <ThrowOnError extends boolean = false>(
  options: Options<BatchCreateProviderItemsData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    BatchCreateProviderItemsResponse,
    BatchCreateProviderItemsError,
    ThrowOnError
  >({
    ...options,
    url: '/provider/item/batchCreate',
  });
};

/**
 * @deprecated
 * Update model item
 * Update an existing model item
 */
export const updateProviderItem = <ThrowOnError extends boolean = false>(
  options: Options<UpdateProviderItemData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    UpdateProviderItemResponse,
    UpdateProviderItemError,
    ThrowOnError
  >({
    ...options,
    url: '/provider/item/update',
  });
};

/**
 * @deprecated
 * Batch update provider items
 * Batch update provider items
 */
export const batchUpdateProviderItems = <ThrowOnError extends boolean = false>(
  options: Options<BatchUpdateProviderItemsData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    BatchUpdateProviderItemsResponse,
    BatchUpdateProviderItemsError,
    ThrowOnError
  >({
    ...options,
    url: '/provider/item/batchUpdate',
  });
};

/**
 * @deprecated
 * Delete provider item
 * Delete an existing model item
 */
export const deleteProviderItem = <ThrowOnError extends boolean = false>(
  options: Options<DeleteProviderItemData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    DeleteProviderItemResponse,
    DeleteProviderItemError,
    ThrowOnError
  >({
    ...options,
    url: '/provider/item/delete',
  });
};

/**
 * List tool
 * List all available tools, including regular tools and MCP servers.
 */
export const listTools = <ThrowOnError extends boolean = false>(
  options?: Options<ListToolsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<ListToolsResponse2, ListToolsError, ThrowOnError>({
    ...options,
    url: '/tool/list',
  });
};

/**
 * List user tools
 * Get installed tools and unauthorized external OAuth tools for current user.
 */
export const listUserTools = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<ListUserToolsResponse2, ListUserToolsError, ThrowOnError>({
    ...options,
    url: '/tool/user/list',
  });
};

/**
 * List toolset inventory
 * List all available toolsets in inventory, including uninstalled.
 */
export const listToolsetInventory = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListToolsetInventoryResponse2,
    ListToolsetInventoryError,
    ThrowOnError
  >({
    ...options,
    url: '/tool/inventory/list',
  });
};

/**
 * List toolsets
 * List all installed toolsets
 */
export const listToolsets = <ThrowOnError extends boolean = false>(
  options?: Options<ListToolsetsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<ListToolsetsResponse2, ListToolsetsError, ThrowOnError>({
    ...options,
    url: '/tool/toolset/list',
  });
};

/**
 * Create regular tool
 * Create a new regular tool
 */
export const createToolset = <ThrowOnError extends boolean = false>(
  options: Options<CreateToolsetData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<CreateToolsetResponse, CreateToolsetError, ThrowOnError>({
    ...options,
    url: '/tool/toolset/create',
  });
};

/**
 * Update toolset
 * Update an existing toolset
 */
export const updateToolset = <ThrowOnError extends boolean = false>(
  options: Options<UpdateToolsetData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<UpdateToolsetResponse, UpdateToolsetError, ThrowOnError>({
    ...options,
    url: '/tool/toolset/update',
  });
};

/**
 * Delete toolset
 * Delete an existing toolset
 */
export const deleteToolset = <ThrowOnError extends boolean = false>(
  options: Options<DeleteToolsetData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<DeleteToolsetResponse, DeleteToolsetError, ThrowOnError>({
    ...options,
    url: '/tool/toolset/delete',
  });
};

/**
 * Export toolset definitions
 * Export tool schemas for specified toolsets. Used for generating Python SDK.
 */
export const exportToolsetDefinitions = <ThrowOnError extends boolean = false>(
  options?: Options<ExportToolsetDefinitionsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ExportToolsetDefinitionsResponse2,
    ExportToolsetDefinitionsError,
    ThrowOnError
  >({
    ...options,
    url: '/tool/toolset/exportDefinitions',
  });
};

/**
 * Execute tool
 * Execute a tool by toolset key and tool name.
 */
export const executeTool = <ThrowOnError extends boolean = false>(
  options: Options<ExecuteToolData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<ExecuteToolResponse2, ExecuteToolError, ThrowOnError>({
    ...options,
    url: '/tool/execute',
  });
};

/**
 * Get tool call result
 * Get the result of a tool call
 */
export const getToolCallResult = <ThrowOnError extends boolean = false>(
  options: Options<GetToolCallResultData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetToolCallResultResponse2,
    GetToolCallResultError,
    ThrowOnError
  >({
    ...options,
    url: '/tool/call/result',
  });
};

/**
 * Authorize Composio connection
 * Generate an OAuth authorization URL for a Composio integration.
 */
export const authorizeComposioConnection = <ThrowOnError extends boolean = false>(
  options: Options<AuthorizeComposioConnectionData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    AuthorizeComposioConnectionResponse,
    AuthorizeComposioConnectionError,
    ThrowOnError
  >({
    ...options,
    url: '/tool/composio/{app}/authorize',
  });
};

/**
 * Revoke Composio connection
 * Revoke a user's Composio connection and reset OAuth state.
 */
export const revokeComposioConnection = <ThrowOnError extends boolean = false>(
  options: Options<RevokeComposioConnectionData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    RevokeComposioConnectionResponse,
    RevokeComposioConnectionError,
    ThrowOnError
  >({
    ...options,
    url: '/tool/composio/{app}/revoke',
  });
};

/**
 * Get Composio connection status
 * Query the current Composio connection status for a user by app slug.
 */
export const getComposioConnectionStatus = <ThrowOnError extends boolean = false>(
  options: Options<GetComposioConnectionStatusData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetComposioConnectionStatusResponse,
    GetComposioConnectionStatusError,
    ThrowOnError
  >({
    ...options,
    url: '/tool/composio/{app}/status',
  });
};

/**
 * Scrape
 * Scrape a weblink
 */
export const scrape = <ThrowOnError extends boolean = false>(
  options: Options<ScrapeData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<ScrapeResponse, ScrapeError, ThrowOnError>({
    ...options,
    url: '/misc/scrape',
  });
};

/**
 * Upload
 * Upload a file
 */
export const upload = <ThrowOnError extends boolean = false>(
  options: Options<UploadData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<UploadResponse2, UploadError, ThrowOnError>({
    ...options,
    ...formDataBodySerializer,
    headers: {
      'Content-Type': null,
      ...options?.headers,
    },
    url: '/misc/upload',
  });
};

/**
 * Serve static
 * Serve static files (only for local testing)
 */
export const serveStatic = <ThrowOnError extends boolean = false>(
  options: Options<ServeStaticData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<ServeStaticResponse, ServeStaticError, ThrowOnError>({
    ...options,
    url: '/misc/static/{objectKey}',
  });
};

/**
 * Convert between formats
 * Convert content between different formats (e.g., HTML to Markdown)
 */
export const convert = <ThrowOnError extends boolean = false>(
  options: Options<ConvertData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<ConvertResponse2, ConvertError, ThrowOnError>({
    ...options,
    ...formDataBodySerializer,
    headers: {
      'Content-Type': null,
      ...options?.headers,
    },
    url: '/misc/convert',
  });
};

/**
 * 获取工作台提示词建议
 * 获取当前用户在工作台 Copilot 输入框中使用的示例提示词。
 */
export const getPromptSuggestions = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetPromptSuggestionsResponse2,
    GetPromptSuggestionsError,
    ThrowOnError
  >({
    ...options,
    url: '/misc/promptSuggestions',
  });
};

/**
 * Get available vouchers
 * Get user's available (unused, not expired) vouchers
 */
export const getAvailableVouchers = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetAvailableVouchersResponse2,
    GetAvailableVouchersError,
    ThrowOnError
  >({
    ...options,
    url: '/voucher/available',
  });
};

/**
 * List user vouchers
 * List all vouchers for the current user
 */
export const listUserVouchers = <ThrowOnError extends boolean = false>(
  options?: Options<unknown, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListUserVouchersResponse2,
    ListUserVouchersError,
    ThrowOnError
  >({
    ...options,
    url: '/voucher/list',
  });
};

/**
 * Validate voucher
 * Validate a voucher before use
 */
export const validateVoucher = <ThrowOnError extends boolean = false>(
  options: Options<ValidateVoucherData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    ValidateVoucherResponse2,
    ValidateVoucherError,
    ThrowOnError
  >({
    ...options,
    url: '/voucher/validate',
  });
};

/**
 * Create voucher invitation
 * Create a sharing invitation for a voucher
 */
export const createVoucherInvitation = <ThrowOnError extends boolean = false>(
  options: Options<CreateVoucherInvitationData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreateVoucherInvitationResponse2,
    CreateVoucherInvitationError,
    ThrowOnError
  >({
    ...options,
    url: '/voucher/invitation/create',
  });
};

/**
 * Verify invitation code
 * Verify an invitation code (public endpoint)
 */
export const verifyVoucherInvitation = <ThrowOnError extends boolean = false>(
  options: Options<VerifyVoucherInvitationData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    VerifyVoucherInvitationResponse2,
    VerifyVoucherInvitationError,
    ThrowOnError
  >({
    ...options,
    url: '/voucher/invitation/verify',
  });
};

/**
 * Claim invitation
 * Claim an invitation and receive a voucher
 */
export const claimVoucherInvitation = <ThrowOnError extends boolean = false>(
  options: Options<ClaimVoucherInvitationData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    ClaimVoucherInvitationResponse2,
    ClaimVoucherInvitationError,
    ThrowOnError
  >({
    ...options,
    url: '/voucher/invitation/claim',
  });
};

/**
 * 获取提示词技能列表
 * 返回当前用户未删除的提示词技能，支持按技能名搜索和按创建时间排序。列表项不含说明文档正文。
 */
export const listPromptSkills = <ThrowOnError extends boolean = false>(
  options?: Options<ListPromptSkillsData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    ListPromptSkillsResponse,
    ListPromptSkillsError,
    ThrowOnError
  >({
    ...options,
    url: '/prompt-skill/list',
  });
};

/**
 * 获取提示词技能详情
 * 返回技能的完整信息，含 Markdown 说明文档。非本人技能返回未找到。
 */
export const getPromptSkillDetail = <ThrowOnError extends boolean = false>(
  options: Options<GetPromptSkillDetailData, ThrowOnError>,
) => {
  return (options?.client ?? client).get<
    GetPromptSkillDetailResponse,
    GetPromptSkillDetailError,
    ThrowOnError
  >({
    ...options,
    url: '/prompt-skill/detail',
  });
};

/**
 * 创建提示词技能
 * 手动创建提示词技能。创建后默认为停用状态，需手动启用后才会进入 AI 能力清单。
 */
export const createPromptSkill = <ThrowOnError extends boolean = false>(
  options: Options<CreatePromptSkillData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    CreatePromptSkillResponse,
    CreatePromptSkillError,
    ThrowOnError
  >({
    ...options,
    url: '/prompt-skill/create',
  });
};

/**
 * 更新提示词技能
 * 更新技能的标题、描述或说明文档，三者至少提供一个。
 */
export const updatePromptSkill = <ThrowOnError extends boolean = false>(
  options: Options<UpdatePromptSkillData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    UpdatePromptSkillResponse,
    UpdatePromptSkillError,
    ThrowOnError
  >({
    ...options,
    url: '/prompt-skill/update',
  });
};

/**
 * 启用或停用提示词技能
 * 只切换启用状态。启用后该技能才会进入 AI 能力清单。
 */
export const togglePromptSkill = <ThrowOnError extends boolean = false>(
  options: Options<TogglePromptSkillData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    TogglePromptSkillResponse,
    TogglePromptSkillError,
    ThrowOnError
  >({
    ...options,
    url: '/prompt-skill/toggle',
  });
};

/**
 * 删除提示词技能
 * 软删除当前用户的提示词技能。
 */
export const deletePromptSkill = <ThrowOnError extends boolean = false>(
  options: Options<DeletePromptSkillData, ThrowOnError>,
) => {
  return (options?.client ?? client).post<
    DeletePromptSkillResponse,
    DeletePromptSkillError,
    ThrowOnError
  >({
    ...options,
    url: '/prompt-skill/delete',
  });
};
